<div class="innerpage-fullwithbanner">
  <ng-container *ngIf="!isPortfolio">
    <h2 class="bighead" *ngIf="!isInEditMode">Add New Property</h2>
    <h2 class="bighead" *ngIf="isInEditMode">Edit Property Details</h2>
  </ng-container>
  <ng-container *ngIf="isPortfolio">
    <h2 class="bighead" *ngIf="!isInEditMode">Add New Portfolio</h2>
    <h2 class="bighead" *ngIf="isInEditMode">Edit Portfolio Details</h2>
  </ng-container>
  <ul class="bread-crumbs">
    <li>
      <a href="#" [routerLink]="['/']">
        Home
        <span>|</span>
      </a>
    </li>
    <li>
      <a (click)="onBreadCrumbClick();">{{prevPage}}<span>|</span></a>
    </li>

    <ng-container *ngIf="!isPortfolio">
      <li *ngIf="!isInEditMode">Add Property</li>
      <li *ngIf="isInEditMode">Edit Property</li>
    </ng-container>
    <ng-container *ngIf="isPortfolio">
      <li *ngIf="!isInEditMode">Add Portfolio</li>
      <li *ngIf="isInEditMode">Edit Portfolio</li>
    </ng-container>
  </ul>
</div>
<form [formGroup]="propForm" autocomplete="off" #formDir="ngForm" name="form" class="property-form">
  <div class="container container-lg section-margin">
    <div *ngIf="ShowDuplicates" class="duplicate-pro-alert modal-content deletemodal">
      <h6 class="displayvalue" [hidden]="duplicatesFound">Checking for duplicates...</h6>
      <h6 class="displayvalue" [hidden]="!duplicatesFound">Duplicate(s) Identified!</h6>
      <div class="text-right margin-top-20" [hidden]="!duplicatesFound">
        <button class="btn btn-lg btn-border" (click)="showDuplicates(DuplicateProperties,'panlestyle');">View Duplicates</button>
      </div>
    </div>
    <div class="border-div be-box" *ngIf="!isPortfolio">
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Listing Type
              <span class="star">*</span>
            </label>
            <label class="select" *ngIf="enabeListingType">
              <select class="form-control" name="lstPropertyFor" (change)="onPropertyForChanged($event)" formControlName="lstPropertyFor"
                      [(ngModel)]="model.PropertyForId" [ngModelOptions]="{standalone: true}">
                <option [ngValue]="item.id" *ngFor="let item of propertyForList">{{item.description}}</option>
              </select>
              <i></i>
            </label>
            <label class="select" *ngIf="!enabeListingType">
              <select class="form-control" name="lstPropertyFor" [attr.disabled]="true" [ngModelOptions]="{standalone: true}" (change)="onPropertyForChanged($event)" formControlName="lstPropertyFor"
                      [(ngModel)]="model.PropertyForId">
                <option [ngValue]="item.id" *ngFor="let item of propertyForList">{{item.description}}</option>
              </select>
              <i></i>
            </label>

          </div>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
          <div class="form-group">
            <label class="form-label clearfix">
              Status
              <label class="right-align-label" *ngIf="viewSoldDetailsLink">
                <a (click)="openSolidDetails(templateSolidDetails,'panlestyle sold-modal',model.PropertyStatusId)">View Sales info</a>
              </label>
            </label>
            <label class="select">
              <select class="form-control" [ngModelOptions]="{standalone: true}" name="lstPropertyStatus" formControlName="lstPropertyStatus" [(ngModel)]="model.PropertyStatusId" (change)="openSolidDetails(templateSolidDetails,'panlestyle sold-modal',model.PropertyStatusId)">

                <option [ngValue]="item.id" *ngFor="let item of propertyStatusList">{{item.description}}</option>

              </select>
              <i></i>
            </label>

          </div>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
          <div class="form-group checkbox-margin-top">
            <label class="form-label hidden-xs">&nbsp;</label>
            <label class="custom-checkbox margin-bottom-0 margin-right-20" for="checkboxArchive">
              <input type="checkbox" [ngModelOptions]="{standalone: true}" formControlName="chkArchive" [(ngModel)]="model.IsArchive" id="checkboxArchive">
              Archive
              <i></i>
            </label>
            <label class="custom-checkbox" for="chkPortfolioSaleOnly">
              <input type="checkbox" [ngModelOptions]="{standalone: true}" formControlName="chkPortfolioSaleOnly" [(ngModel)]="model.PortfolioSaleOnly" id="chkPortfolioSaleOnly">
              Portfolio Sale only
              <i></i>
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Brokerage
              <!--<span class="star">*</span>-->
            </label>
            <label class="select">
              <select formControlName="lstBrokerage" [ngModelOptions]="{standalone: true}" [(ngModel)]="model.BrokerageId" class="form-control" (change)="onBrokerageChange()">
                <option [ngValue]="null">Select</option>
                <option *ngFor="let brokerage of brokerageList" [(ngValue)]="brokerage.Id">{{brokerage.BrokerageName}}</option>
              </select>
              <i></i>
            </label>
            <div *ngIf="(lstBrokerage.invalid && isSubmitted) ||(lstBrokerage.invalid && (lstBrokerage.dirty || lstBrokerage.touched))">
              <p class="redtext" *ngIf="lstBrokerage.errors.required">
                Brokerage is required
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Property Source URL
              <label class="right-align-label" *ngIf="model.IsSourceChanged === 1">
                <a target="_blank" href="{{model.PropertySource}}">View Update</a>
              </label>
            </label>
            <input type="text" formControlName="txtPropertSource" [ngModelOptions]="{standalone: true}" placeholder="http://.." maxlength="500" [(ngModel)]="model.PropertySource" class="form-control">
          </div>
        </div>

      </div>
      <div class="row">

        <div class="col-xs-12">
          <div>
            <div class="floatinghead floatinghead-xs clearfix">
              <h2 class="mainhead">
                <span class="text">External Broker</span>
              </h2>
              <a (click)="openModalBrokerage(BrokerageBroker,'panlestyle add-broker-modal')" tooltip="Add external broker" placement="left" class="right-btn btn  btn-circle btn-green adduserbtn">
                <i class="icofont icofont-plus icon" aria-hidden="true"></i>
              </a>
            </div>
            <div *ngIf="this.brokerslist === null || this.brokerslist.length === 0" class="nodata">
              <i class="icofont icofont-warning icon"></i>
              <p>No Brokers Added</p>
            </div>
            <div *ngIf="this.brokerslist !== null && this.brokerslist.length > 0" class="table-responsive">
              <table class="table basictable">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Direct</th>
                    <th [hidden]="!authService.Admin()&&!authService.SuperAdmin()">Mobile</th>
                    <th>Title</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of brokerslist; let i = index">

                    <td>
                      <p>{{item.BrokerName}}</p>
                    </td>
                    <td>
                      <p>
                        {{item.Email ? item.Email : '-' }}
                      </p>
                    </td>
                    <td>
                      <p>{{item.Phone ? (item.Phone | phone) : '-'}}</p>
                    </td>
                    <td [hidden]="!authService.Admin()&&!authService.SuperAdmin()">
                      <p>{{item.AdditionalPhone ? (item.AdditionalPhone | phone) : '-'}}</p>
                    </td>
                    <td>
                      <p>{{item.Title ? (item.Title) : '-'}}</p>
                    </td>
                    <td>
                      <a href="javascript:void(0);" (click)="openModelForDeleteBrocker(templateBrockerDelete,deletemodal,i) " class="remove" tooltip="Remove" placement="top">
                        <i class="icofont icofont-close" aria-hidden="true"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <br />
      <h2 class="mainhead">
        <span class="text">Tenant Name</span>
      </h2>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group autocomplete-design">
            <label class="form-label">
              Tenant
              <span class="star">*</span>
              <label class="custom-checkbox" style="float:right; height:10px">
                <input formControlName="chkNewTenantInfo" [ngModelOptions]="{standalone: true}" #newTenantInfo [(ngModel)]="model.IsNewTenant" id="checkbox12" type="checkbox" (click)="checkNewTenant(newTenantInfo.checked)" [ngModelOptions]="{standalone: true}">
                <i class="helper"></i> New Tenant
              </label>
            </label>
            <!--<ng2-completer [hidden]="model.IsNewTenant" [(ngModel)]="model.TenantName" [textSearching]="model.TenantName" [maxChars]="90" [datasource]="dataService"
            formControlName="txtTenantName" (selected)="onTenantSelect($event)" [overrideSuggested]="true" [minSearchLength]="0" (blur)="onTenantBlur($event)"></ng2-completer>-->
            <!--<ng-select [hidden]="model.IsNewTenant" [(ngModel)]="model.TenantName" [items]="dataService" class="form-control" [searchable]="true" (blur)="onTenantBlur($event)" [virtualScroll]="true" [minTermLength]="0" (change)="onTenantSelect($event)"></ng-select>-->
            <ng-select [items]="dataService$ | async"
                       bindLabel="TenantName"
                       bindValue="TenantName"
                       formControlName="txtTenantName"
                       [hideSelected]="true"
                       [loading]="loading"
                       (change)="onTenantSelect($event)"
                       [typeahead]="dataServiceInput$"
                       [minTermLength]="0"
                       [(ngModel)]="model.TenantName" [ngModelOptions]="{standalone: true}" *ngIf="!model.IsNewTenant">
            </ng-select>
            <input type="text" maxlength="100" [ngModelOptions]="{standalone: true}" *ngIf="model.IsNewTenant" class="form-control" formControlName="txtTenantNameFreeText" [(ngModel)]="model.TenantNameText" />

            <div>
              <p class="redtext" *ngIf="!model.TenantName && isSubmitted && !model.IsNewTenant">
                Tenant Name is required
              </p>
              <p class="redtext" *ngIf="model.TenantName==' ' && isSubmitted && !model.IsNewTenant">
                The value cannot be only white spaces
              </p>
              <p class="redtext" *ngIf="!model.TenantNameText && isSubmitted && model.IsNewTenant">
                Tenant Name is required
              </p>
              <p class="redtext" *ngIf="model.TenantName==' ' && isSubmitted && model.IsNewTenant">
                The value cannot be only white spaces
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Display Name <span *ngIf="model.ShowDisplayName" class="star">*</span>
              <label class="custom-checkbox" style="float:right; height:10px">
                <input [checked]="model.ShowDisplayName" [ngModelOptions]="{standalone: true}" name="chkDisplayName" (change)="enableDisplayName($event)" type="checkbox">
                <i class="helper"></i> Show
              </label>
            </label>
            <input maxlength="100" type="text" [ngModelOptions]="{standalone: true}" formControlName="txtDisplayName" [required]="model.ShowDisplayName" [(ngModel)]="model.DisplayName"
                   class="form-control ">
            <div *ngIf="(txtDisplayName.invalid && isSubmitted )||(txtDisplayName.invalid && (txtDisplayName.dirty || txtDisplayName.touched))">
              <p class="redtext" *ngIf="txtDisplayName.errors.required && model.ShowDisplayName">
                Display name is required
              </p>
              <p class="redtext" *ngIf="txtDisplayName.errors.spaceOnly && model.ShowDisplayName">
                The value cannot be only white spaces
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label hidden-xs hidden-sm">&nbsp;</label>
            <div role="group" class="form-radio">
              <div class="radio radio-inline">
                <label>
                  <input id="Franchisee" type="radio" value="Franchisee" [checked]="!isCorporate" name="rdFranchisee" formControlName="rdFranchisee" (change)="onFranchiseChange('fr')">
                  <i class="helper"></i>Franchisee
                </label>
              </div>
              <div class="radio radio-inline">
                <label>
                  <input id="Corporate" type="radio" value="Corporate" [checked]="isCorporate" name="rdFranchisee" formControlName="rdFranchisee" (change)="onFranchiseChange('cr')">
                  <i class="helper"></i>Corporate
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">

          <div class="form-group">
            <label class="form-label">
              Guarantor
              <label class="custom-checkbox" style="float:right; height:10px">
                <input formControlName="chkGurantorInfo" #newGuarantor [(ngModel)]="model.IsNewGuarantor" id="checkbox12" (click)="checkNewGuarantor(newGuarantor.checked)" type="checkbox"> New Guarantor
                <i></i>
              </label>
            </label>
            <label class="select" *ngIf="!model.IsNewGuarantor">
              <select [ngModelOptions]="{standalone: true}" class="form-control" formControlName="drpGuarantor" (change)="onGuarantorChanges();" [(ngModel)]="model.GuarantorId">
                <option [ngValue]="null">Select</option>
                <option *ngFor="let guarantor of guarantorList" [(ngValue)]="guarantor.Id">{{guarantor.Name}}</option>
              </select>
              <i></i>
            </label>
            <input type="text" maxlength="100" *ngIf="model.IsNewGuarantor" class="form-control" formControlName="txtGuarantorNameText" [(ngModel)]="model.GuarantorName" />

          </div>
        </div>
        <!--<div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Guarantor Name(FreeText)
            </label>
            <input type="text" [attr.disabled]="!model.IsNewGuarantor ? '' : null" class="form-control" formControlName="txtGuarantorNameText" [(ngModel)]="model.GuarantorName" />

          </div>
        </div>-->

      </div>
      <div class="row" role="group" aria-labelledby="_rating">

        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">S&amp;P Rating</label>
            <label class="select">
              <select formControlName="lstSandP" [ngModelOptions]="{standalone: true}" [(ngModel)]="model.SPRatingId" class="form-control ">
                <option [value]="null">Select</option>
                <option *ngFor="let item of sprRatingList" [(ngValue)]="item.id">{{item.description}}</option>
              </select>
              <i></i>
            </label>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Moody's Rating</label>
            <label class="select">
              <select [ngModelOptions]="{standalone: true}" formControlName="lstMoodyRating" [(ngModel)]="model.MoodyRatingId"
                      class="form-control ">
                <option [value]="null">Select</option>
                <option *ngFor="let item of moodysRatingList" [(ngValue)]="item.id">{{item.description}}</option>
              </select>
              <i></i>
            </label>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group ">
            <label class="form-label">Fitch Rating</label>
            <label class="select">
              <select [ngModelOptions]="{standalone: true}" formControlName="fitchRating" [(ngModel)]="model.FitchRatingId"
                      class="form-control">
                <option [value]="null">Select</option>
                <option *ngFor="let item of fitchRatingList" [(ngValue)]="item.id">{{item.description}}</option>
              </select>
              <i></i>
            </label>
          </div>
        </div>
        <div *ngIf="isPropertyForSale" class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Number of Units
              <!--<span *ngIf="model.IsFranchisee" class="star">*</span>-->
            </label>
            <input [ngModelOptions]="{standalone: true}" type="text" mask="99999" formControlName="txtNumberOfUnits" [min]="isFranchise ? 1 : 0"
                   [(ngModel)]="model.NoOfUnits" class="form-control ">
            <div *ngIf="(txtNumberOfUnits.invalid && isSubmitted)||(txtNumberOfUnits.invalid && (txtNumberOfUnits.dirty || txtNumberOfUnits.touched))">
              <p class="redtext" *ngIf="txtNumberOfUnits.errors.required">Enter number of franchicies</p>
              <p class="redtext" *ngIf="txtNumberOfUnits.errors.min">Number of units must be greater than 0</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="border-div" [hidden]="isPortfolio">
      <div class="floatinghead clearfix">
        <h2 class="mainhead">
          <span class="text">Location</span>
        </h2>
        <div class="rightcheckbox" *ngIf="authService.Admin()||authService.SuperAdmin()">
          <label class="custom-checkbox margin-right-15" for="checkbox18">
            <input readonly="readonly" formControlName="chkConfidentialLocation" [(ngModel)]="model.ConfidentialLocation" id="checkbox18" type="checkbox"> Confidential Location
            <i></i>
          </label>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Street Address
              <span class="star">*</span>
            </label>
            <input [(ngModel)]="model.Address" #addresstext (change)="onDuplicateChecking();" formControlName="txtAddress" name="txtAddress" required maxlength="190" type="text" class="form-control" (ngModelChange)="onStreetAddressChange()">
            <div *ngIf="(txtAddress.invalid && isSubmitted)||(txtAddress.invalid && (txtAddress.dirty || txtAddress.touched))">
              <p class="redtext" *ngIf="txtAddress.errors.spaceOnly">
                The value cannot be only white spaces
              </p>
              <p class="redtext" *ngIf="txtAddress.errors.required">
                Address is required
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              State
              <span class="star">*</span>
            </label>
            <label class="select">
              <select class="form-control" formControlName="lstState" (change)="bindCity()" [(ngModel)]="model.StateId">
                <option [ngValue]="null">Select</option>
                <option *ngFor="let state of statesList" [(ngValue)]="state.Id">{{state.Name}}</option>
              </select>
              <i></i>
            </label>
            <div *ngIf="(lstState.invalid && isSubmitted)||(lstState.invalid && (lstState.dirty || lstState.touched))">
              <p class="redtext" *ngIf="lstState.errors.required">
                State is required
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              City
              <span class="star">*</span>
            </label>
            <label class="select">
              <select formControlName="lstCity" [(ngModel)]="model.CityId" class="form-control " (change)="callZipChange($event)">
                <option [ngValue]="null">Select</option>
                <option *ngFor="let city of citiesList" [(ngValue)]="city.Id">{{city.Name}}</option>
              </select>
              <i></i>
            </label>
            <div *ngIf="(lstCity.invalid && isSubmitted) ||(lstCity.invalid && (lstCity.dirty || lstCity.touched))">
              <p class="redtext" *ngIf="lstCity.errors.required">
                City is required
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Zip
              <span class="star">*</span>
            </label>
            <input formControlName="txtZip" (change)="callZipChange($event)" [(ngModel)]="model.Zip" maxlength="10" mask="00000" required
                   type="text" class="form-control ">

            <div *ngIf="(txtZip.invalid && isSubmitted) || (txtZip.invalid && (txtZip.dirty || txtZip.touched))">
              <p class="redtext" *ngIf="txtZip.errors.required">
                Zip is required
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row d-none">

      </div>
      <div class="d-flex chart-box-header align-item-center margin-bottom-20 div-no-prop-background">
        <h5 class="mr-auto margin-bottom-0">
          <i container="body" class="userpermissiontooltip margin-right-5" triggers="mouseenter:mouseleave" aria-hidden="true" placement="right">
            <img src="/assets/img/Frame.svg" class="info-icon-blue-position">
          </i>
          <span>Select Street Address From Google Maps Dropdown For Best Results</span>
        </h5>
      </div>
      <div class="mapdiv">
        <input type="hidden" formControlName="lat" [(ngModel)]="model.Latitude">
        <input type="hidden" formControlName="lon" [(ngModel)]="model.Longitude">
        <div #gmap style="width:100%;height:350px"></div>
      </div>
    </div>
    <div class="border-div" *ngIf="!isPortfolio">
      <div class="floatinghead floatinghead-xs clearfix">
        <h2 class="mainhead">
          <span class="text">Property Info</span>
        </h2>
        <div class="rightcheckbox">
          <label class="custom-checkbox" for="checkbox11">
            <input formControlName="chkIsFeatured" [checked]="model.IsFeatured" (change)="model.IsFeatured = !model.IsFeatured" class="border-checkbox"
                   id="checkbox11" type="checkbox"> Featured
            <i></i>
          </label>

        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Year Built
              <span class="star">*</span>
            </label>
            <input type="text" mask="0000" [ngModelOptions]="{standalone: true}" formControlName="txtYearBuilt" [min]="1850" [max]="today.getFullYear()" required [(ngModel)]="model.YearBuilt"
                   class="form-control ">
            <div *ngIf="(txtYearBuilt.invalid && isSubmitted) || (txtYearBuilt.invalid && (txtYearBuilt.dirty || txtYearBuilt.touched))">
              <p class="redtext" *ngIf="txtYearBuilt.errors.required">
                Year of built is required
              </p>
              <p class="redtext" *ngIf="txtYearBuilt.errors.min">The year of built must be greater or equal to 1850</p>
              <p class="redtext" *ngIf="txtYearBuilt.errors.max">
                The year cannot be greater than {{today.getFullYear()}}
              </p>
            </div>
          </div>
        </div>
        <div *ngIf="isPropertyForSale" class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Renovated
            </label>
            <input type="text" [ngModelOptions]="{standalone: true}" mask="0000" formControlName="txtRenovated" ng-minlength="4" [min]="model.YearBuilt" [(ngModel)]="model.Renovated"
                   class="form-control">


            <div *ngIf="(txtRenovated.invalid && isSubmitted) || (txtRenovated.invalid && (txtRenovated.dirty || txtRenovated.touched))">

              <p class="redtext" *ngIf="txtRenovated.errors.minlength">
                Please enter a valid year
              </p>

              <p class="redtext" *ngIf="(model.Renovated.length==4) && (txtRenovated.errors.minValue)">

                <!--The year cannot be less than {{model.YearBuilt}}-->
                The renovated year cannot be less than year of built
              </p>

              <p class="redtext" *ngIf="txtRenovated.errors.max">
                The year cannot be greater than {{today.getFullYear()}}
              </p>

            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Property Type
              <span class="star">*</span>
            </label>

            <div class="select-dropdown multiselectdesign">
              <mat-form-field>
                <mat-select formControlName="lstPropertyType" [ngModelOptions]="{standalone: true}" placeholder="Select" [(ngModel)]="model.PropertyTypeList" (ngModelChange)="bindSubCategories($event);" multiple>
                  @if (model?.PropertyTypeList.length > 1) {
                  <mat-select-trigger (click)="$event.stopPropagation()">
                    <span>{{ model?.PropertyTypeList.length }} items selected</span>
                  </mat-select-trigger>
                  }
                  @for (propertyType of propertyTypesList; track propertyType) {
                  <mat-option [value]="propertyType.id" class="multi-dropdown-item">{{propertyType.name}}</mat-option>
                  }
                  <mat-option class="matoptionnodata" *ngIf="propertyTypesList.length === 0" disabled>
                    Nothing found...
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div *ngIf="(lstPropertyType.invalid && isSubmitted)">
              <p class="redtext" *ngIf="lstPropertyType.errors.required">
                Property type is required
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Subcategory</label>

            <div class="select-dropdown multiselectdesign">
              <mat-form-field>
                <mat-select formControlName="lstSubcatgeories"
                            placeholder="Select"
                            [(ngModel)]="model.PropertyTypeSubcategoryList"
                            [ngModelOptions]="{standalone: true}"
                            [multiple]="true">
                  <mat-select-trigger *ngIf="model?.PropertyTypeSubcategoryList?.length > 1">
                    <span>{{ model?.PropertyTypeSubcategoryList?.length }} items selected</span>
                  </mat-select-trigger>
                  <mat-option *ngFor="let item of subCategoriesList" class="multi-dropdown-item" [value]="item.id">
                    {{item.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Property Characteristics</label>
            <div class="select-dropdown multiselectdesign">
              <mat-form-field>
                <mat-select formControlName="lstCharacteristic"
                            placeholder="Select"
                            [(ngModel)]="model.CharacteristicsId"
                            [ngModelOptions]="{standalone: true}"
                            [multiple]="true"
                            (selectionChange)="onPropertyCharacteristicsChange()">
                  <mat-select-trigger *ngIf="model?.CharacteristicsId?.length > 1">
                    <span>{{ model?.CharacteristicsId?.length }} items selected</span>
                  </mat-select-trigger>

                  <mat-option *ngFor="let item of characteristicList" class="multi-dropdown-item" [value]="item.id">
                    {{item.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Building SF
              <span class="star">*</span>
            </label>
            <div class="textbox-with-4character textbox-with-btn">
              <input type="text" inputmode="decimal" class="form-control" formControlName="txtBuildingSF" min="1" [min]="1" maxlength="18" dropSpecialCharacters="false" mask="separator.10.2" thousandSeparator=","
                     [(ngModel)]="model.BuildingSize" [ngModelOptions]="{standalone: true}" (change)="validationService.onlyDecimal($event);" (keyup)="updatePSF()">
              <span class="rightlabel">SQ FT</span>
            </div>
            <div *ngIf="(txtBuildingSF.invalid && isSubmitted)||(txtBuildingSF.invalid && (txtBuildingSF.dirty || txtBuildingSF.touched))">
              <p class="redtext" *ngIf="txtBuildingSF.errors.required">
                Building size is required
              </p>
              <p class="redtext" *ngIf="txtBuildingSF.errors.min">
                Building size should be greater than 0
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Land (AC)</label>
            <div class="textbox-with-4character textbox-with-btn">
              <input min="0.001" [min]="0.001" type="text" mask="999999999.99" [dropSpecialCharacters]="false" formControlName="txtland" [(ngModel)]="model.Land" [ngModelOptions]="{standalone: true}"
                     class="form-control " (change)="validationService.onlyDecimal($event);">
              <span class="rightlabel">acre</span>
            </div>
            <div *ngIf="(txtland.invalid && isSubmitted)||(txtland.invalid && (txtland.dirty || txtland.touched))">
              <p class="redtext" *ngIf="txtland.errors.min">
                Land area should be greater than 0
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="form-group">
            <label class="form-label">Description</label>
            <textarea [(ngModel)]="model.Description" formControlName="txtDescription"
                      class="form-control property-description" maxlength="3000"
                      rows="3" [ngModelOptions]="{standalone: true}"></textarea>
          </div>
          <div *ngIf="(txtDescription.invalid && isSubmitted)||(txtDescription.invalid && (txtDescription.dirty || txtDescription.touched))">
            <p class="redtext" *ngIf="txtDescription.errors.maxlength">
              Length of description cannot be exceed of 4000 charecters
            </p>
          </div>
          <div class="form-group" *ngIf="isInEditMode && model.PropertyForId == 601">
            <label class="form-label">Meta Tags</label>
            <textarea [(ngModel)]="model.MetaTags" formControlName="txtMetaTags"
                      class="form-control property-metatags" maxlength="1000"
                      rows="3" [ngModelOptions]="{standalone: true}"></textarea>
          </div>
          <div *ngIf="(txtMetaTags.invalid && isSubmitted)||(txtMetaTags.invalid && (txtMetaTags.dirty || txtMetaTags.touched))">
            <p class="redtext" *ngIf="txtMetaTags.errors.maxlength">
              Length of meta tags cannot be exceed of 1000 characters
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="border-div" *ngIf="isPortfolio">
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Listing Type
              <span class="star">*</span>
            </label>
            <label class="select">
              <select class="form-control" name="lstPropertyFor" [attr.disabled]="model.PropertyForId == 602" (change)="onPortfolioPropertyForChanged($event)" formControlName="lstPropertyFor"
                      [(ngModel)]="model.PropertyForId" [ngModelOptions]="{standalone: true}">
                <option [ngValue]="item.id" *ngFor="let item of propertyForList">{{item.description}}</option>
              </select>
              <i></i>
            </label>
            <div *ngIf="(lstPropertyFor.invalid && isSubmitted )||(lstPropertyFor.invalid && (lstPropertyFor.dirty || lstPropertyFor.touched))">
              <p class="redtext" *ngIf="lstPropertyFor.errors.required">
                Choose whether the adding property is for sale or 1031 exchange
              </p>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
          <div class="form-group">
            <label class="form-label clearfix">
              Status
              <label class="right-align-label" *ngIf="viewSoldDetailsLink">
                <a (click)="openSolidDetails(templateSolidDetails,'panlestyle sold-modal',model.PropertyStatusId)">View Sales info</a>
              </label>
            </label>
            <label class="select">
              <select class="form-control" name="lstPropertyStatus" formControlName="lstPropertyStatus" [(ngModel)]="model.PropertyStatusId" (change)="openSolidDetails(templateSolidDetails,'panlestyle sold-modal',model.PropertyStatusId)" [ngModelOptions]="{standalone: true}">

                <option [ngValue]="item.id" *ngFor="let item of propertyStatusList">{{item.description}}</option>

              </select>
              <i></i>
            </label>

          </div>
        </div>
        <!--*ngIf="userRole != 9 "-->
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
          <div class="form-group checkbox-margin-top">
            <label class="form-label hidden-xs">&nbsp;</label>
            <label class="custom-checkbox margin-bottom-0 margin-right-20" for="checkboxArchive">
              <input type="checkbox" formControlName="chkArchive" [(ngModel)]="model.IsArchive" id="checkboxArchive" [ngModelOptions]="{standalone: true}">
              Archive
              <i></i>
            </label>
            <label class="custom-checkbox margin-bottom-0" for="checkboxIsOfferOnAllProperties">
              <input type="checkbox" formControlName="chkIsOfferOnAllProperties" [(ngModel)]="model.IsOfferOnAllProperties" id="checkboxIsOfferOnAllProperties" [ngModelOptions]="{standalone: true}">
              Full Portfolio Offers Only
              <i></i>
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Brokerage
              <!--<span class="star">*</span>-->
            </label>
            <label class="select">
              <select formControlName="lstBrokerage" [(ngModel)]="model.BrokerageId" class="form-control" (change)="onBrokerageChange()" [ngModelOptions]="{standalone: true}">
                <option [ngValue]="null">Select</option>
                <option *ngFor="let brokerage of brokerageList" [(ngValue)]="brokerage.Id">{{brokerage.BrokerageName}}</option>
              </select>
              <i></i>
            </label>
            <div *ngIf="(lstBrokerage.invalid && isSubmitted) ||(lstBrokerage.invalid && (lstBrokerage.dirty || lstBrokerage.touched))">
              <p class="redtext" *ngIf="lstBrokerage.errors.required">
                Brokerage is required
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Property Source URL
              <label class="right-align-label" *ngIf="model.IsSourceChanged === 1">
                <a target="_blank" href="{{model.PropertySource}}">View Update</a>
              </label>
            </label>
            <input type="text" formControlName="txtPropertSource" placeholder="http://.." maxlength="500" [(ngModel)]="model.PropertySource" class="form-control" [ngModelOptions]="{standalone: true}">
          </div>
        </div>
        <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12">
          <div class="form-group checkbox-margin-top">
            <label class="form-label hidden-xs">&nbsp;</label>
            <label class="custom-checkbox margin-bottom-0 margin-right-20" for="checkboxZeroCashFlow">
              <input type="checkbox" formControlName="chkZeroCashflow" [(ngModel)]="model.OnlyZCF" (change)="checkZeroCashflow($event)" id="checkboxZeroCashFlow" [ngModelOptions]="{standalone: true}">
              Zero Cash Flow
              <i></i>
            </label>
          </div>
        </div>
      </div>
      <div class="row">

        <div class="col-xs-12">
          <div>
            <div class="floatinghead floatinghead-xs clearfix">
              <h2 class="mainhead">
                <span class="text">External Broker</span>
              </h2>
              <a (click)="openModalBrokerage(BrokerageBroker,'panlestyle add-broker-modal')" tooltip="Add external broker" placement="left" class="right-btn btn  btn-circle btn-green adduserbtn">
                <i class="icofont icofont-plus icon" aria-hidden="true"></i>
              </a>
            </div>
            <div *ngIf="this.brokerslist === null || this.brokerslist.length === 0" class="nodata">
              <i class="icofont icofont-warning icon"></i>
              <p>No Brokers Added</p>
            </div>
            <div *ngIf="this.brokerslist !== null && this.brokerslist.length > 0" class="table-responsive">
              <table class="table basictable">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Title</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of brokerslist; let i = index">

                    <td>
                      <p>{{item.BrokerName}}</p>
                    </td>
                    <td>
                      <p>
                        {{item.Email ? item.Email : '-' }}
                      </p>
                    </td>
                    <td>
                      <p>{{item.Phone ? (item.Phone | phone) : '-'}}</p>
                    </td>
                    <td>
                      <p>{{item.Title ? (item.Title) : '-'}}</p>
                    </td>
                    <td>
                      <a href="javascript:void(0);" (click)="openModelForDeleteBrocker(templateBrockerDelete,deletemodal,i) " class="remove" tooltip="Remove" placement="top">
                        <i class="icofont icofont-close" aria-hidden="true"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div _ngcontent-oqc-c0="" class="floatinghead floatinghead-xs clearfix">
        <h2 class="mainhead">
          <span class="text">Portfolio Properties</span>
        </h2>
        <button class="right-btn btn  btn-circle btn-green adduserbtn" tooltip="Add Property" (click)="viewSuggestProperties(PropertySuggest,'suggestproperty')" placement="left" class="right-btn btn  btn-circle btn-green adduserbtn">
          <i class="icofont icofont-plus icon" aria-hidden="true"></i>
        </button>
        <span class="pull-right" *ngIf="model.OnlyZCF" style="margin-right: 10px;margin-top: 8px;">You can only add ZCF listings to this portfolio</span>
      </div>

      <!--<div class="text-right tradepipeline-topbar clearfix margin-bottom-10">
          <button class="btn btn-sm bluelink" (click)="viewSuggestProperties(PropertySuggest,'suggestproperty');">Suggest Properties</button>
      </div>-->
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="table-responsive">
            <table class="table basictable row-border hover">
              <thead>
                <tr>
                  <th class="remove" style="position:static; cursor:auto;">Action</th>
                  <th>OM</th>
                  <th>Property Id</th>
                  <th class="property-name-column">Tenant</th>
                  <th>State</th>
                  <th>City</th>
                  <th>Listing Type</th>
                  <th>Property Type</th>
                  <th>Property Status</th>
                  <th>Asking Price</th>
                  <th>Rent NOI</th>
                  <th>Credit Rating</th>
                  <th>Cap Rate</th>
                  <th>Remaining Term</th>
                  <th>Lease Structure</th>
                  <th>Area (SQ FT)</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="portfolioSelectedProperties.length > 0">
                  <tr *ngFor="let prop of portfolioSelectedProperties; let i = index">
                    <td>
                      <label class="custom-checkbox withoutlabel">
                        <!-- <input [disabled]="prop.DisabledSelection" type="checkbox" [(ngModel)]="prop.IsChecked" (ngModelChange)="onChecked(prop);">-->
                        <a class="remove" tooltip="Remove" href="javascript:void(0);" (click)="openRemovePortfolioProperty(i)"><i class="icofont icofont-close" aria-hidden="true"></i></a>
                        <i></i>
                      </label>
                    </td>
                    <td>
                      <span *ngIf="prop.OMFilePath == null">-</span>
                      <a *ngIf="prop.OMFilePath!=null" href={{prop.OMFilePath}} download="Document.pdf" target="_blank" [ngClass]="{'border-link':(prop.OMFilePath!=null)}">
                        <i *ngIf="prop.OMFilePath!=null" aria-hidden="true" class="icofont icofont-download-alt downloadicon"></i>{{prop.OMFilePath!=null?'OM':'-'}}
                      </a>
                    </td>
                    <td><p>{{ prop.PropertySequenceId }}</p></td>
                    <td class="min-width-td"><p><a target="_blank" href="#" routerLink="/viewdeproperty/{{prop.Guid}}">{{ prop.PropertyName }}</a></p></td>
                    <td><p>{{ prop.State ? prop.State : '-' }}</p></td>
                    <td><p>{{ prop.City ? prop.City : '-' }}</p></td>
                    <td><p>{{ prop.PropertyFor }}</p></td>

                    <td>
                      <p tooltip="{{prop.AssetType}}" *ngIf="(prop.AssetType && !prop.PropertyType) || (prop.AssetType && prop.PropertyType)">{{ prop.AssetType ? _commonService.GetPropertyTypeWithCount(prop.AssetType) : '-' }}</p>
                      <p tooltip="{{prop.PropertyType}}" *ngIf="prop.PropertyType && !prop.AssetType">{{ prop.PropertyType ? _commonService.GetPropertyTypeWithCount(prop.PropertyType) : '-' }}</p>
                    </td>
                    <td><p [ngClass]="{'redtextlabel':(prop.PropertyStatus === 'Closed' || prop.PropertyStatus === 'Sold' || prop.PropertyStatus === 'Not Available' || prop.PropertyStatus === 'Off-Market'),'greentextlabel':prop.PropertyStatus === 'Available','orangetextlabel':prop.PropertyStatus === 'Under Contract'}">{{ prop.PropertyStatus }}</p></td>
                    <td>
                      <p class="whitespacenowrap" *ngIf="!prop.Unpriced">{{(prop.Price && prop.IsShowPrice) ? '$ '+(prop.Price |number:0) : '-'}}</p>
                      <p class="whitespacenowrap" *ngIf="prop.Unpriced">Unpriced</p>
                    </td>
                    <td><p class="whitespacenowrap">{{ (prop.RentNOI) ? '$ '+(prop.RentNOI | number:0) : '-' }}</p></td>
                    <td><p>{{ prop.RatingType ? prop.RatingType + (prop.Rating ? ' (' + prop.Rating + ')' : '') : '-' }}</p></td>
                    <td>
                      <p *ngIf="prop.CharacteristicsId == 1">ZCF</p>
                      <p *ngIf="prop.CharacteristicsId == 0">{{ (prop.CapRate && prop.IsShowPrice) ? (prop.CapRate | number : '1.2-2') + '%' : '-'}}</p>
                    </td>
                    <td><p class="whitespacenowrap">{{ prop.RemainingTerm ? (prop.RemainingTerm | yearsMonthConverter:true) : '-'}}</p></td>
                    <td><p class="whitespacenowrap">{{ prop.LeaseStructure ? prop.LeaseStructure : '-'}}</p></td>
                    <td><p>{{ prop.BuildingSize ? (prop.BuildingSize |number:0) : '-' }}</p></td>
                  </tr>
                </ng-container>
                <tr *ngIf="portfolioSelectedProperties?.length === 0">
                  <td colspan="15" class="no-data-available">
                    <div class="nodata">
                      <i class="fa fa-exclamation-triangle icon"></i>
                      <p>No Data Available</p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="border-div" *ngIf="isPortfolio">
      <h2 class="mainhead">
        <span class="text">Portfolio Summary</span>
      </h2>
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Portfolio Name <span class="star">*</span>
            </label>
            <input type="text" formControlName="txtDisplayName" [required]="true" maxlength="100" [(ngModel)]="model.DisplayName"
                   class="form-control " [ngModelOptions]="{standalone: true}">
            <div *ngIf="(txtDisplayName.invalid && isSubmitted )||(txtDisplayName.invalid && (txtDisplayName.dirty || txtDisplayName.touched))">
              <p class="redtext" *ngIf="txtDisplayName.errors.required">
                Portfolio Name is required
              </p>
              <p class="redtext" *ngIf="txtDisplayName.errors.spaceOnly">
                The value cannot be only white spaces
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Number Of Locations
              <label class="custom-checkbox " style="float:right; height:10px" for="chkNumberOfLocations">
                <input #inputNumberOfLocations formControlName="chkAutoCalcNumberOfLocations" id="chkNumberOfLocations" (click)="autoCalcFields(1, inputNumberOfLocations.checked)" type="checkbox" [(ngModel)]="model.AutoCalcNumberOfLocations" [ngModelOptions]="{standalone: true}"> Auto Calc
                <i></i>
              </label>
            </label>
            <input type="text" mask="999999999" formControlName="txtNumberOfLocations" [(ngModel)]="model.NumberOfLocations" (keyup)="model.AutoCalcNumberOfLocations = false"
                   class="form-control" [ngModelOptions]="{standalone: true}">
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Number Of Properties
              <label class="custom-checkbox " style="float:right; height:10px" for="chkNumberOfProperties">
                <input #inputNumberOfProperties formControlName="chkAutoCalcNumberOfProperties" id="chkNumberOfProperties" (click)="autoCalcFields(2, inputNumberOfProperties.checked)" type="checkbox" [(ngModel)]="model.AutoCalcNumberOfProperties" [ngModelOptions]="{standalone: true}"> Auto Calc
                <i></i>
              </label>
            </label>
            <input type="text" mask="999999999" formControlName="txtNumberOfProperties" [(ngModel)]="model.NumberOfProperties" [ngModelOptions]="{standalone: true}" (keyup)="model.AutoCalcNumberOfProperties = false"
                   class="form-control ">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="form-group">
            <label class="form-label">Description</label>
            <textarea [(ngModel)]="model.Description" formControlName="txtDescription"
                      [ngModelOptions]="{standalone: true}"
                      class="form-control property-description" maxlength="3000"
                      rows="3"></textarea>
          </div>
          <div *ngIf="(txtDescription.invalid && isSubmitted)||(txtDescription.invalid && (txtDescription.dirty || txtDescription.touched))">
            <p class="redtext" *ngIf="txtDescription.errors.maxlength">
              Length of description cannot be exceed of 4000 charecters
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="border-div" *ngIf="isPortfolio">
      <h2 class="mainhead">
        <span class="text">Lease Summary</span>
        <!--<button [disabled]="disableAddEditHistoryButton" type="button" class="btn  btn-circle btn-green margin-bottom pull-right"
                aria-controls="dropdown-basic" (click)="openSalesHistoryAdd('hdnLeasingHistory')" tooltip="Add New Leasing History"
                placement="left">
            <i aria-hidden="true" class="fa fa-plus icon"></i>
        </button>-->
      </h2>
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Portfolio Type
              <span class="star">*</span>
              <label class="custom-checkbox " style="float:right; height:10px" for="chkPropertyType">
                <input #inputCalcPortfolioType formControlName="chkAutoCalcPortfolioType" id="chkPropertyType" (click)="autoCalcFields(3, inputCalcPortfolioType.checked)" type="checkbox" [(ngModel)]="model.AutoCalcPortfolioType"> Auto Populate
                <i></i>
              </label>
            </label>
            <div class="select-dropdown multiselectdesign">
              <mat-form-field>
                <mat-select formControlName="lstPropertyType"
                            placeholder="Select"
                            [(ngModel)]="model.PropertyTypeList"
                            (ngModelChange)="bindSubCategories($event)"
                            [multiple]="true" [ngModelOptions]="{standalone: true}">
                  <mat-select-trigger *ngIf="model?.PropertyTypeList?.length > 1">
                    <span>{{ model?.PropertyTypeList?.length }} items selected</span>
                  </mat-select-trigger>
                  <mat-option *ngFor="let type of propertyTypesList" class="multi-dropdown-item" [value]="type.id">
                    {{type.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div *ngIf="(lstPropertyType.invalid && isSubmitted)">
              <p class="redtext" *ngIf="lstPropertyType.errors.required">
                Portfolio type is required
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              <!--Portfolio--> Subcategory
              <label class="custom-checkbox " style="float:right; height:10px" for="chkSubcatgeories">
                <input #inputCalcPortfolioSubcategory formControlName="chkAutoCalcPortfolioSubcategory" id="chkSubcatgeories" (click)="autoCalcFields(4, inputCalcPortfolioSubcategory.checked)" type="checkbox" [(ngModel)]="model.AutoCalcPortfolioSubcategory" [ngModelOptions]="{standalone: true}"> Auto Populate
                <i></i>
              </label>
            </label>
            <div class="select-dropdown multiselectdesign">
              <div class="select-dropdown multiselectdesign">
                <mat-form-field>
                  <mat-select name="lstSubcatgeories" placeholder="Select" [(ngModel)]="model.PropertyTypeSubcategoryList" (ngModelChange)="bindAutoCalc(4,inputCalcPortfolioSubcategory.checked, isInitialLoad)" [ngModelOptions]="{standalone: true}" multiple>
                    @if (model?.PropertyTypeSubcategoryList?.length > 1) {
                    <mat-select-trigger (click)="$event.stopPropagation()">
                      <span>{{ model?.PropertyTypeSubcategoryList?.length }} items selected</span>
                    </mat-select-trigger>
                    }
                    @for (subCategory of subCategoriesList; track subCategory) {
                    <mat-option [value]="subCategory.id" class="multi-dropdown-item">{{subCategory.name}}</mat-option>
                    }
                    <mat-option class="matoptionnodata" *ngIf="subCategoriesList.length === 0" disabled>
                      Nothing found...
                    </mat-option>
                  </mat-select>
                </mat-form-field>

              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Ownership Type
              <label class="custom-checkbox " style="float:right; height:10px" for="chkOwnershipType">
                <input #inputCalcOwnershipType formControlName="chkAutoCalcOwnershipType" id="chkOwnershipType" (click)="autoCalcFields(5, inputCalcOwnershipType.checked)" type="checkbox" [(ngModel)]="model.AutoCalcOwnershipType" [ngModelOptions]="{standalone: true}"> Auto Populate
                <i></i>
              </label>
            </label>
            <div class="select-dropdown multiselectdesign">
              <mat-form-field>
                <mat-select formControlName="lstOwnershipType"
                            [ngModelOptions]="{standalone: true}"
                            placeholder="Select"
                            [(ngModel)]="model.OwnershipTypeIds"
                            [multiple]="true"
                            (selectionChange)="bindAutoCalc(5,inputCalcOwnershipType.checked, isInitialLoad)">
                  <mat-select-trigger *ngIf="model?.OwnershipTypeIds?.length > 1">
                    <span>{{ model?.OwnershipTypeIds?.length }} items selected</span>
                  </mat-select-trigger>
                  <mat-option *ngFor="let item of ownershipTypelist" class="multi-dropdown-item" [value]="item.id">
                    {{item.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <!--<div *ngIf="(lstOwnershipType.invalid && isSubmitted)|| (lstOwnershipType.invalid && (lstOwnershipType.dirty || lstOwnershipType.touched))">
                <p class="redtext" *ngIf="lstOwnershipType.errors.required">
                    Ownership type is required
                </p>
            </div>-->
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Rent
              <label class="custom-checkbox " style="float:right; height:10px" for="chkNOI">
                <input #inputCalcRent formControlName="chkAutoCalcRent" id="chkNOI" (click)="autoCalcFields(6, inputCalcRent.checked)" type="checkbox" [(ngModel)]="model.AutoCalcRent"> Auto Calc
                <i></i>
              </label>
            </label>
            <div class="textbox-with-btn-left">
              <input formControlName="txtNOI" [(ngModel)]="model.NOI" [min]="0" required="required" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }"
                     dropSpecialCharacters="false" class="form-control " value="{{model.NOI|number}}" (keyup)="updateCapRate('NOI');model.AutoCalcRent = false;">
              <span class="leftlabel">$</span>
            </div>
            <!--<div *ngIf="(txtNOI.invalid && isSubmitted)||(txtNOI.invalid && (txtNOI.dirty || txtNOI.touched))">
                <p class="redtext" *ngIf="txtNOI.errors.required">
                    Rent is required
                </p>
                <p class="redtext" *ngIf="txtNOI.errors.min">
                    Rent value should be greater than 0
                </p>
            </div>-->
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
          <div class="form-group autocomplete-design">
            <label class="form-label">
              Tenant
              <label class="custom-checkbox " style="float:right; height:10px" for="chkAutoCalcTenantType">
                <input #inputCalTenant formControlName="chkAutoCalcTenantType" id="chkAutoCalcTenantType" (click)="autoCalcFields(15, inputCalTenant.checked)" type="checkbox" [(ngModel)]="model.AutoCalcTenantType"> Auto Populate
                <i></i>
              </label>
            </label>
            <label class="select">
              <select class="form-control" name="lstTenantType" formControlName="lstTenantType"
                      [(ngModel)]="model.TenantTypeId" (ngModelChange)="bindAutoCalc(12,inputCalTenant.checked, isInitialLoad)">
                <option [ngValue]="item.id" *ngFor="let item of tenantTypeList">{{item.name}}</option>
              </select>
              <i></i>
            </label>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12" *ngIf="false">
          <div class="form-group">
            <label class="form-label">
              Original Lease Term
              <label class="custom-checkbox " style="float:right; height:10px" for="chkOriginalLeaseTerm">
                <input #inputCalcOriginalLeaseTerm formControlName="chkAutoCalcOriginalLeaseTerm" id="chkOriginalLeaseTerm" (click)="autoCalcFields(7, inputCalcOriginalLeaseTerm.checked)" type="checkbox" [(ngModel)]="model.AutoCalcOriginalLeaseTerm"> Auto Calc
                <i></i>
              </label>
            </label>
            <div class="textbox-with-btn textbox-with-4character">
              <!--  <input type="hidden" formControlName="txtOriginalHdn" [(ngModel)]="model.OriginalLeaseTerm" />-->
              <input type="text" formControlName="txtOriginalLeaseTerm" [(ngModel)]="model.PortfolioOriginalLeaseTerm" class="form-control " (keyup)="model.AutoCalcOriginalLeaseTerm = false">
              <!-- <span class="rightlabel">Years</span> -->
            </div>
            <!--<div *ngIf="(txtOriginal.invalid && isSubmitted)||(txtOriginal.invalid && (txtOriginal.dirty || txtOriginal.touched))">
                <p class="redtext" *ngIf="txtOriginal.errors.required">
                    Original term is required
                </p>
                <p class="redtext" *ngIf="txtOriginal.errors.min">
                    Original term should be greater than 0
                </p>
            </div>-->
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12" *ngIf="false">
          <div class="form-group">
            <label class="form-label">
              Commencement
              <label class="custom-checkbox " style="float:right; height:10px" for="chkCommencement">
                <input #inputCalcCommencement formControlName="chkAutoCalcCommencement" (click)="autoCalcFields(8, inputCalcCommencement.checked)" type="checkbox" [(ngModel)]="model.AutoCalcCommencement"> Auto Calc
                <i></i>
              </label>
            </label>
            <div class="textbox-date">
              <input type="text" maxlength="10" name="txtCommencement" formControlName="txtCommencement" id="chkCommencement" (change)="onLeaseDatesChange($event)" (ngModelChange)="bindAutoCalc(8,inputCalcCommencement.checked, isInitialLoad)"
                     [min]="model.YearBuilt" [(ngModel)]="model.LeaseCommencementDate" required="required"
                     class="form-control" bsDatepicker>
              <i class="icofont icofont-ui-calendar icon"></i>
            </div>
            <!--<div *ngIf="(txtCommencement.invalid && isSubmitted)||(txtCommencement.invalid && (txtCommencement.dirty || txtCommencement.touched))">
                <p class="redtext" *ngIf="txtCommencement.errors.required">
                    Commencement date is required
                </p>
                <p class="redtext" *ngIf="txtCommencement.errors.minYear">
                    Commencement date should be after the year of built
                </p>
                <p class="redtext" *ngIf="txtCommencement.errors.maxDate">
                    Commencement date should be in the past
                </p>
                <p class="redtext" *ngIf="model.LeaseCommencementDate =='Invalid Date'">
                    Please enter a valid date
                </p>
            </div>-->
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12" *ngIf="false">
          <div class="form-group">
            <label class="form-label">
              Lease Expiration
              <label class="custom-checkbox " style="float:right; height:10px" for="chkLeaseExpiration">
                <input #inputCalcLeaseExpiration formControlName="chkAutoCalcLeaseExpiration" id="chkLeaseExpiration" (click)="autoCalcFields(9, inputCalcLeaseExpiration.checked)" type="checkbox" [(ngModel)]="model.AutoCalcLeaseExpiration"> Auto Calc
                <i></i>
              </label>
            </label>
            <div class="textbox-date">
              <input type="text" maxlength="10" formControlName="txtExpiration"
                     [(ngModel)]="model.LeaseExpiration" name="txtExpiration" required="required" class="form-control" (ngModelChange)="bindAutoCalc(9,inputCalcLeaseExpiration.checked, isInitialLoad)"
                     bsDatepicker>
              <i class="icofont icofont-ui-calendar icon"></i>
            </div>
            <!--<div *ngIf="(txtExpiration.invalid && isSubmitted)||(txtExpiration.invalid && (txtExpiration.dirty || txtExpiration.touched))">
                <p class="redtext" *ngIf="txtExpiration.errors.required">
                    Lease expiration date is required
                </p>
            </div>-->
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Remaining Lease Term
              <label class="custom-checkbox " style="float:right; height:10px" for="chkRemainingLeaseTerm">
                <input #inputCalcRemainingLeaseTerm formControlName="chkAutoCalcRemainingLeaseTerm" id="chkRemainingLeaseTerm" (click)="autoCalcFields(10, inputCalcRemainingLeaseTerm.checked)" type="checkbox" [(ngModel)]="model.AutoCalcRemainingLeaseTerm"> Auto Calc
                <i></i>
              </label>
            </label>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="textbox-with-4character textbox-with-btn">
                <input type="text" formControlName="txtRemainingLeaseTermYear" [(ngModel)]="model.PortfolioRemainingLeaseTermYear" class="form-control" (keyup)="model.AutoCalcRemainingLeaseTerm=false">
                <span class="rightlabel">Year(s)</span>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="textbox-with-4character textbox-with-btn">
                <input type="text" formControlName="txtRemainingLeaseTermMonth" [(ngModel)]="model.PortfolioRemainingLeaseTermMonth" class="form-control" (keyup)="model.AutoCalcRemainingLeaseTerm=false">
                <span class="rightlabel">Months</span>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Lease Type
              <label class="custom-checkbox " style="float:right; height:10px" for="chkLeaseStructure">
                <input #inputCalcLeaseType formControlName="chkAutoCalcLeaseType" id="chkLeaseStructure" (click)="autoCalcFields(11, inputCalcLeaseType.checked)" type="checkbox" [(ngModel)]="model.AutoCalcLeaseType"> Auto Populate
                <i></i>
              </label>
            </label>
            <div class="select-dropdown multiselectdesign">
              <mat-form-field>
                <mat-select formControlName="lstLeaseStructure"
                            placeholder="Select"
                            [(ngModel)]="model.LeaseStructureIds"
                            [ngModelOptions]="{standalone: true}"
                            [multiple]="true"
                            (selectionChange)="bindAutoCalc(11,inputCalcLeaseType.checked, isInitialLoad)">
                  <mat-select-trigger *ngIf="model?.LeaseStructureIds?.length > 1">
                    <span>{{ model?.LeaseStructureIds?.length }} items selected</span>
                  </mat-select-trigger>
                  <mat-option *ngFor="let item of leaseStructureMultiList" class="multi-dropdown-item" [value]="item.id">
                    {{item.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Total Land (AC)
              <label class="custom-checkbox " style="float:right; height:10px" for="chkLand">
                <input #inputCalcLand formControlName="chkAutoCalcLand" id="chkLand" (click)="autoCalcFields(16, inputCalcLand.checked)" type="checkbox" [(ngModel)]="model.AutoCalcLand"> Auto Calc
                <i></i>
              </label>
            </label>
            <div class="textbox-with-4character textbox-with-btn">
              <input min="0.001" [min]="0.001" type="text" mask="999999999.99" [dropSpecialCharacters]="false" formControlName="txtland" name="land" [(ngModel)]="model.Land"
                     class="form-control " (change)="validationService.onlyDecimal($event);" (keyup)="model.AutoCalcLand=false">
              <span class="rightlabel">acre</span>
            </div>
            <div *ngIf="(txtland.invalid && isSubmitted)||(txtland.invalid && (txtland.dirty || txtland.touched))">
              <p class="redtext" *ngIf="txtland.errors.min">
                Land area should be greater than 0
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Total Building SF
              <!--<span class="star" *ngIf="!IsBOV">*</span>-->
              <label class="custom-checkbox " style="float:right; height:10px" for="chkBuildingSize">
                <input #inputCalcBuildingSize formControlName="chkAutoCalcBuildingSize" id="chkBuildingSize" (click)="autoCalcFields(17, inputCalcBuildingSize.checked)" type="checkbox" [(ngModel)]="model.AutoCalcBuildingSize"> Auto Calc
                <i></i>
              </label>
            </label>
            <div class="textbox-with-4character textbox-with-btn">
              <input type="text" class="form-control" name="txtBuildingSF" min="1" [min]="1" [dropSpecialCharacters]="false" mask="999999999.99" formControlName="txtBuildingSF"
                     [(ngModel)]="model.BuildingSize" (change)="validationService.onlyDecimal($event);" (keyup)="updatePSF();model.AutoCalcBuildingSize = false"
                     value="{{model.BuildingSize | number}}">


              <span class="rightlabel">SQ FT</span>
            </div>
            <div *ngIf="(txtBuildingSF.invalid && isSubmitted)||(txtBuildingSF.invalid && (txtBuildingSF.dirty || txtBuildingSF.touched))">
              <p class="redtext" *ngIf="txtBuildingSF.errors.required">
                Building size is required
              </p>
              <p class="redtext" *ngIf="txtBuildingSF.errors.min">
                Building size should be greater than 0
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">

        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12" *ngIf="false">
          <div class="form-group">
            <label class="form-label">
              Rental Increase
              <label class="custom-checkbox " style="float:right; height:10px" for="chkEscalationPercentage">
                <input #inputRentalIncrease formControlName="chkAutoCalcRentalIncrease" id="chkEscalationPercentage" (click)="autoCalcFields(12, inputRentalIncrease.checked)" type="checkbox" [(ngModel)]="model.AutoCalcRentalIncrease"> Auto Calc
                <i></i>
              </label>
            </label>
            <div class="textbox-with-btn textbox-with-2character">
              <input formControlName="txtEscalationPercentage" [max]="100" [min]="0" [(ngModel)]="model.RentEscalationPercentage" type="text"
                     [dropSpecialCharacters]="false" mask="999.99" class="form-control" (change)="validationService.onlyDecimal($event);" (keyup)="model.AutoCalcRentalIncrease=false">
              <span class="rightlabel">%</span>
            </div>
            <!--<div *ngIf="(txtEscalationPercentage.invalid && isSubmitted)||(txtEscalationPercentage.invalid && (txtEscalationPercentage.dirty || txtEscalationPercentage.touched))">
                <p class="redtext" *ngIf="txtEscalationPercentage.errors.max">
                    Escalation percentage cannot be greater than 100
                </p>
                <p class="redtext" *ngIf="txtEscalationPercentage.errors.min">
                    Escalation percentage cannot be less than 0
                </p>
            </div>-->
          </div>
        </div>
      </div>
      <div class="row margin-bottom-20" *ngIf="false">
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <label class="bluelabel">Option</label>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">
                  Number
                  <label class="custom-checkbox " style="float:right; height:10px" for="chkOptionNumber">
                    <input #inputOptionNumber formControlName="chkAutoCalcOptionNumber" id="chkOptionNumber" (click)="autoCalcFields(13, inputOptionNumber.checked)" type="checkbox" [(ngModel)]="model.AutoCalcOptionNumber"> Auto Calc
                    <i></i>
                  </label>
                </label>
                <input formControlName="txtOptionNumber" min="0" [(ngModel)]="model.OptionNumber" type="text" mask="999999999" class="form-control " (keyup)="model.AutoCalcOptionNumber=false">
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">
                  Length
                  <label class="custom-checkbox " style="float:right; height:10px" for="chkOptionLength">
                    <input #inputOptionLength id="chkOptionLength" formControlName="chkAutoCalcOptionLength" (click)="autoCalcFields(14, inputOptionLength.checked)" type="checkbox" [(ngModel)]="model.AutoCalcOptionLength"> Auto Calc
                    <i></i>
                  </label>
                </label>
                <div class="textbox-with-btn textbox-with-4character">
                  <input formControlName="txtOptionLength" min="0" [(ngModel)]="model.OptionLength" type="text" mask="9999" class="form-control " (keyup)="model.AutoCalcOptionLength=false">
                  <span class="rightlabel">Year(s)</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="border-div" *ngIf="!isPortfolio">
      <h2 class="mainhead">
        <span class="text">Lease Info</span>
        <button [disabled]="disableAddEditHistoryButton" type="button" class="btn  btn-circle btn-green margin-bottom pull-right"
                aria-controls="dropdown-basic" *ngIf="authService.Admin()||authService.SuperAdmin()" (click)="openSalesHistoryAdd('hdnLeasingHistory')" triggers="mouseenter:mouseleave" tooltip="Add New Leasing History"
                placement="left">
          <i aria-hidden="true" class="fa fa-plus icon"></i>
        </button>
      </h2>
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Lease Structure
              <span class="star">*</span>
            </label>
            <label class="select">
              <select class="form-control" formControlName="lstLeaseStructure" [(ngModel)]="model.LeaseStructureId">
                <option [ngValue]="null">Select</option>
                <option [ngValue]="str.id" *ngFor="let str of leaseStructureList">{{str.description}}</option>
              </select>
              <i></i>
            </label>
            <div *ngIf="(lstLeaseStructure.invalid && isSubmitted) ||(lstLeaseStructure.invalid && (lstLeaseStructure.dirty || lstLeaseStructure.touched))">
              <p class="redtext" *ngIf="lstLeaseStructure.errors.required">
                Lease structure is required
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">
              Ownership Type
              <span class="star">*</span>
            </label>
            <label class="select">
              <select class="form-control" formControlName="lstOwnershipType" [(ngModel)]="model.OwnershipTypeId">
                <option [ngValue]="null">Select</option>
                <option [ngValue]="item.id" *ngFor="let item of ownershipList">{{item.description}}</option>
              </select>
              <i></i>
            </label>
            <div *ngIf="(lstOwnershipType.invalid && isSubmitted)|| (lstOwnershipType.invalid && (lstOwnershipType.dirty || lstOwnershipType.touched))">
              <p class="redtext" *ngIf="lstOwnershipType.errors.required">
                Ownership type is required
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-{{ this.model.PropertyForId === 601 ? '6' : '3'}} col-md-{{ this.model.PropertyForId === 601 ? '6' : '3'}} col-sm-12 col-xs-12">
          <label class="bluelabel">Rent</label>
          <div class="row">
            <div class="col-lg-{{ this.model.PropertyForId === 601 ? '6' : '12'}} col-md-{{ this.model.PropertyForId === 601 ? '6' : '12'}} col-sm-{{ this.model.PropertyForId === 601 ? '6' : '12'}} col-xs-12">
              <div class="form-group">
                <label class="form-label">
                  Rent / NOI
                  <span class="star">*</span>
                </label>
                <div class="textbox-with-btn-left">
                  <input formControlName="txtNOI" [(ngModel)]="model.NOI" [min]="0" required="required" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }"
                         dropSpecialCharacters="false" class="form-control " (keyup)="updateCapRate('NOI')" value="{{model.NOI|number}}" (ngModelChange)="propertyRentTermsFielsChange()">
                  <span class="leftlabel">$</span>
                </div>
                <div *ngIf="(txtNOI.invalid && isSubmitted)||(txtNOI.invalid && (txtNOI.dirty || txtNOI.touched))">
                  <p class="redtext" *ngIf="txtNOI.errors.required">
                    Rent / NOI is required
                  </p>
                  <p class="redtext" *ngIf="txtNOI.errors.min">
                    Rent / NOI value should be greater than 0
                  </p>
                </div>
              </div>
            </div>
            <div *ngIf="isPropertyForSale" class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">
                  RPSF
                  <span class="star">*</span>
                </label>
                <div class="textbox-with-btn-left">
                  <input type="text" inputmode="numeric" formControlName="txtPSF" disabled [dropSpecialCharacters]="false" mask="999999999999999.99"
                         [(ngModel)]="model.LeasePricePSF" [ngModelOptions]="{standalone: true}" class="form-control " maxlength="21" thousandSeparator="," (change)="validationService.onlyDecimal($event);">
                  <span class="leftlabel">$</span>
                </div>
                <div *ngIf="(txtPSF.invalid && isSubmitted)||(txtPSF.invalid && (txtPSF.dirty || txtPSF.touched))">
                  <p class="redtext" *ngIf="txtPSF.errors.required">
                    RPSF is required
                  </p>
                  <p class="redtext" *ngIf="txtPSF.errors.min">
                    RPSF value should be greater than 0
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <label class="bluelabel">Lease (Date)</label>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">
                  Commencement
                  <span class="star">*</span>
                </label>
                <div class="textbox-date">
                  <input type="text" maxlength="10" name="txtCommencement" formControlName="txtCommencement" (change)="onLeaseDatesChange($event)"
                         [min]="model.YearBuilt" [(ngModel)]="model.LeaseCommencementDate" required="required"
                         class="form-control" bsDatepicker (ngModelChange)="propertyRentTermsFielsChange()">
                  <i class="icofont icofont-ui-calendar icon"></i>
                </div>
                <div *ngIf="(txtCommencement.invalid && isSubmitted)||(txtCommencement.invalid && (txtCommencement.dirty || txtCommencement.touched))">
                  <p class="redtext" *ngIf="txtCommencement.errors.required">
                    Commencement date is required
                  </p>
                  <p class="redtext" *ngIf="txtCommencement.errors.minYear">
                    Commencement date should be after the year of built
                  </p>
                  <p class="redtext" *ngIf="txtCommencement.errors.maxDate">
                    Commencement date should be in the past
                  </p>
                  <p class="redtext" *ngIf="model.LeaseCommencementDate =='Invalid Date'">
                    Please enter a valid date
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">
                  Expiration
                  <span class="star">*</span>
                </label>
                <div class="textbox-date">
                  <input type="text" maxlength="10" [min]="model.YearBuilt" formControlName="txtExpiration" (change)="onLeaseDatesChange($event)"
                         [(ngModel)]="model.LeaseExpiration" name="txtExpiration" required="required" class="form-control"
                         bsDatepicker (ngModelChange)="propertyRentTermsFielsChange()">
                  <i class="icofont icofont-ui-calendar icon"></i>
                </div>
                <div *ngIf="(txtExpiration.invalid && isSubmitted)||(txtExpiration.invalid && (txtExpiration.dirty || txtExpiration.touched))">
                  <p class="redtext" *ngIf="txtExpiration.errors.required">
                    Lease expiration date is required
                  </p>
                  <p class="redtext" *ngIf="txtExpiration.errors.minDate">
                    Lease expiration date should be after the commencement date
                  </p>
                  <p class="redtext" *ngIf="model.LeaseExpiration =='Invalid Date'">
                    Please enter a valid date
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div *ngIf="isPropertyForSale" class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <label class="bluelabel">
            Term (in years)
            <!-- <span class="star">*</span> -->
          </label>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">
                  Original
                  <span class="star">*</span>
                </label>
                <div class="textbox-with-btn textbox-with-4character">
                  <input type="hidden" formControlName="txtOriginalHdn" [(ngModel)]="model.OriginalLeaseTerm" />
                  <input type="text" mask="9999" disabled formControlName="txtOriginal" min="0" [value]="[model.LeaseExpiration | yearsGapBetweenDates: model.LeaseCommencementDate]"
                         class="form-control ">
                  <!-- <span class="rightlabel">Years</span> -->
                </div>
                <div *ngIf="(txtOriginal.invalid && isSubmitted)||(txtOriginal.invalid && (txtOriginal.dirty || txtOriginal.touched))">
                  <p class="redtext" *ngIf="txtOriginal.errors.required">
                    Original term is required
                  </p>
                  <p class="redtext" *ngIf="txtOriginal.errors.min">
                    Original term should be greater than 0
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Remaining</label>
                <div class="textbox-with-btn textbox-with-4character">
                  <input type="text" disabled="disabled" [value]="[model.LeaseExpiration | propRemainingTerm: model.LeaseCommencementDate]"
                         class="form-control">
                  <!-- <span class="rightlabel">Years</span> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <label class="bluelabel">Escalation</label>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Percentage</label>
                <div class="textbox-with-btn textbox-with-2character">
                  <input formControlName="txtEscalationPercentage" inputmode="numeric" [max]="100" [min]="0" [(ngModel)]="model.RentEscalationPercentage" type="text"
                         [dropSpecialCharacters]="false" mask="999.99" class="form-control" (change)="validationService.onlyDecimal($event);" (ngModelChange)="propertyRentTermsFielsChange()">
                  <span class="rightlabel">%</span>
                </div>
                <div *ngIf="(txtEscalationPercentage.invalid && isSubmitted)||(txtEscalationPercentage.invalid && (txtEscalationPercentage.dirty || txtEscalationPercentage.touched))">
                  <p class="redtext" *ngIf="txtEscalationPercentage.errors.max">
                    Escalation percentage cannot be greater than 100
                  </p>
                  <p class="redtext" *ngIf="txtEscalationPercentage.errors.min">
                    Escalation percentage cannot be less than 0
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Period</label>
                <div class="textbox-with-btn textbox-with-4character">
                  <input formControlName="txtEscalationYrs" min="0" [min]="0" [(ngModel)]="model.RentEscalationPeriod" type="text" mask="9999"
                         class="form-control " (ngModelChange)="propertyRentTermsFielsChange()">
                  <span class="rightlabel">Year(s)</span>
                </div>
                <div *ngIf="(txtEscalationYrs.invalid && isSubmitted)||(txtEscalationYrs.invalid && (txtEscalationYrs.dirty || txtEscalationYrs.touched))">
                  <p class="redtext" *ngIf="txtEscalationYrs.errors.min">
                    Escalation period cannot be less than 0
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row margin-bottom-20">
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <label class="bluelabel">Option</label>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Number</label>
                <input formControlName="txtOptionNumber" min="0" [(ngModel)]="model.OptionNumber" type="text" mask="999999999" class="form-control " (ngModelChange)="propertyRentTermsFielsChange()">
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="form-group">
                <label class="form-label">Length</label>
                <div class="textbox-with-btn textbox-with-4character">
                  <input formControlName="txtOptionLength" min="0" [(ngModel)]="model.OptionLength" type="text" mask="9999" class="form-control " (ngModelChange)="propertyRentTermsFielsChange()">
                  <span class="rightlabel">Year(s)</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">

        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">

        </div>
      </div>
      <div>
        <div class="floatinghead clearfix">
          <h2 class="mainhead">
            <span class="text">NOI / Rent Schedule</span>
          </h2>
          <div class="rightcheckbox">
            <label class="custom-checkbox margin-right-15" for="checkbox16">
              <input readonly="readonly" formControlName="chkRentScheduleInfo" [(ngModel)]="model.IsShowRentSchedule" id="checkbox16" type="checkbox"> Show Rent Schedule
              <i></i>
            </label>
            <label class="custom-checkbox margin-right-15" for="checkbox17">
              <input readonly="readonly" formControlName="chkRentTermAutoCalc" [(ngModel)]="retnTermAutoCalcValue" (click)="openAutoCalcRentTermModal(templateAutoCalcRentTerm,'deletemodal',model.IsRentTermAutoCalc)" id="checkbox17" type="checkbox"> Auto populate Rent Schedule
              <i></i>
            </label>
            <button *ngIf="!retnTermAutoCalcValue" href="#" tooltip="Add A Rent Term" (click)="addRentTerm()" placement="left" class="right-btn btn  btn-circle btn-green adduserbtn">
              <i class="icofont icofont-plus icon" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div>
          <app-rent-term-table [IsDataEntryProperty]="true" (updateLoadStatus)="updateLoadStatus($event)" (rentTerm)="saveRentTerm($event)" [propertyId]="model.Id" [InitialLoad]="InitialLoad" [rentTermsAutoCalc]="retnTermAutoCalcValue" [rentTerms]="rentTerms" [PropertyRentTerms]="model.PropertyRentTerm" [IsEditAllowed]="true"></app-rent-term-table>
        </div>
      </div>
      <ng-container *ngIf="(this.model.Id != null && this.model.Id > 0) || !isInEditMode">
        <div class="property-more-details-box">
          <app-property-lease-history-list [canEditHistory]="true" (disableAddEditHistoryButton)="disableButton($event)" (saveSaleHistory)="saveSaleHistory($event)" [propertyId]="this.model.Id" [IsDataEntryPrperty]="true" [propertyModel]="this.model" [transactionTypeId]="6501"></app-property-lease-history-list>
        </div>
      </ng-container>
    </div>
    <div class="border-div property-more-details-box" *ngIf="!isPortfolio">
      <h2 class="mainhead">
        <span class="text">Sale Records</span>

        <button [disabled]="disableAddEditHistoryButton" type="button" class="btn  btn-circle btn-green margin-bottom pull-right"
                aria-controls="dropdown-basic" *ngIf="authService.Admin()||authService.SuperAdmin()" (click)="openSalesHistoryAdd('hdnSalesHistory')" triggers="mouseenter:mouseleave" tooltip="Add New Sale History"
                placement="left">
          <i aria-hidden="true" class="fa fa-plus icon"></i>
        </button>
      </h2>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <ng-container *ngIf="(this.model.Id != null && this.model.Id > 0) || !isInEditMode">
            <app-sale-history-list [canEditHistory]="true" (disableAddEditHistoryButton)="disableButton($event)" (saveSaleHistory)="saveSaleHistory($event)" [propertyId]="this.model.Id" [IsDataEntryPrperty]="true" [propertyModel]="this.model" [transactionTypeId]="6500"></app-sale-history-list>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="border-div">
      <div class="floatinghead clearfix">
        <h2 class="mainhead">
          <span class="text">Pricing Info</span>
        </h2>
        <div class="rightcheckbox">
          <label class="custom-checkbox margin-right-15" for="checkbox18">
            <input readonly="readonly" formControlName="chkUnpriced" (click)="UnpricedClick($event)" [(ngModel)]="model.Unpriced" id="checkbox18" type="checkbox"> Unpriced
            <i></i>
          </label>
          <label class="custom-checkbox " for="checkbox12">
            <input formControlName="chkPricingInfo" [(ngModel)]="model.IsShowPrice" id="checkbox12" type="checkbox"> Show Pricing Info
            <i></i>
          </label>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 col-xs-12" [ngClass]="(isPortfolio)?'col-lg-4 col-md-4':'col-lg-3 col-md-3'">
          <div class="form-group">
            <label class="form-label">
              Asking Price
              <span class="star">*</span>
              <label class="custom-checkbox " style="float:right; height:10px" for="chkCalcPrice" *ngIf="isPortfolio">
                <input #inputCalcPrice id="chkCalcPrice" formControlName="chkAutoCalcPrice" (click)="calcPrice(inputCalcPrice.checked)" type="checkbox" [(ngModel)]="model.AutoCalcPrice"> Auto Calc
                <i></i>
              </label>
            </label>
            <div *ngIf="!model.Unpriced" class="textbox-with-btn-left">
              <input type="text" formControlName="txtAskingPrice" [dropSpecialCharacters]="false" currencyMask maxlength="18" [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true' }" (keyup)="updateCapRate('AskingPrice');model.AutoCalcPrice=false" [(ngModel)]="model.Price"
                     class="form-control " value="{{model.Price|toNumber|number}}">
              <span class="leftlabel">$</span>
              <div *ngIf="(txtAskingPrice.invalid && isSubmitted)|| (txtAskingPrice.invalid && (txtAskingPrice.dirty || txtAskingPrice.touched))">
                <p class="redtext" *ngIf="txtAskingPrice.errors.required">
                  Asking Price is required
                </p>
                <!--<p class="redtext" *ngIf="txtAskingPrice.errors.min">
                  Asking Price should be greater than zero
                </p>-->
              </div>
            </div>
            <div *ngIf="model.Unpriced">
              <input type="text" disabled formControlName="txtUnpricedText" [(ngModel)]="model.UnpricedText"
                     class="form-control">
            </div>

          </div>
        </div>
        <div class="col-sm-6 col-xs-12" [ngClass]="(isPortfolio)?'col-lg-4 col-md-4':'col-lg-3 col-md-3'">
          <div class="form-group">
            <label class="form-label">
              Price PSF
              <label class="custom-checkbox " for="checkbox12" style="float:right; height:10px" for="chkCalcPSF">
                <input id="chkCalcPSF" #inputCalcPSF formControlName="chkAutoCalcPSF" (click)="reCalcRates(1,inputCalcPSF.checked)" type="checkbox" [(ngModel)]="model.AutoCalcPSF"> Auto Calc PSF
                <i></i>
              </label>
            </label>
            <div class="textbox-with-btn-left" *ngIf="!model.Unpriced">
              <input type="text" inputmode="numeric" (keyup)="model.AutoCalcPSF=false" thousandSeparator="," maxlength="21" mask="separator.10.2" [dropSpecialCharacters]="false" name="txtPricePSF" [(ngModel)]="model.PricePSF" [ngModelOptions]="{standalone: true}" (change)="validationService.onlyDecimal($event);"
                     class="form-control">
              <span class="leftlabel">$</span>
            </div>
            <div class="form-group" *ngIf="model.Unpriced">
              <input type="text" disabled formControlName="txtUnpricedText" [(ngModel)]="model.UnpricedText"
                     class="form-control">
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-xs-12" [ngClass]="(isPortfolio)?'col-lg-4 col-md-4':'col-lg-3 col-md-3'">
          <div class="form-group">
            <label class="form-label">
              {{capratetext}}
              <label class="custom-checkbox " style="float:right; height:10px" for="chkCalcCAP">
                <input [attr.disabled]="(disableCapRate) ? 'disabled' : null" #inputCalcCAP id="chkCalcCAP" formControlName="chkAutoCalcCapRate" (click)="reCalcRates(2,inputCalcCAP.checked)" type="checkbox" [(ngModel)]="model.AutoCalcCapRate"> Auto Calc <!--Cap Rate-->
                <i></i>
              </label>
            </label>
            <div *ngIf="!model.Unpriced">
              <div class="textbox-with-btn textbox-with-2character">
                <input [attr.disabled]="(disableCapRate) ? 'disabled' : null" (keyup)="model.AutoCalcCapRate=false" type="text" mask="999.99" formControlName="txtCapRate" [dropSpecialCharacters]="false" [(ngModel)]="model.CapRate" class="form-control" (change)="validationService.onlyDecimal($event);">
                <span class="rightlabel">%</span>
              </div>
              <div *ngIf="(txtCapRate.invalid && isSubmitted)||(txtCapRate.invalid && (txtCapRate.dirty || txtCapRate.touched))">
                <p class="redtext" *ngIf="txtCapRate.errors.max">
                  Cap Rate cannot be greater than 100
                </p>
                <p class="redtext" *ngIf="txtCapRate.errors.min">
                  Cap Rate cannot be less than 0
                </p>
              </div>
            </div>
            <div *ngIf="model.Unpriced" class="form-group">
              <input type="text" disabled formControlName="txtCapRateText" [(ngModel)]="model.CapRateText"
                     class="form-control">
            </div>
          </div>

        </div>
        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Date on Market</label>
            <div class="textbox-date">
              <input type="text" formControlName="txtDateOnMarket" name="txtDateOnMarket" maxlength="10" [(ngModel)]="model.DateOnMarket"
                     class="form-control" bsDatepicker>
              <i class="icofont icofont-ui-calendar icon"></i>
              <div *ngIf="(txtDateOnMarket.invalid && isSubmitted) || (txtDateOnMarket.invalid && (txtDateOnMarket.dirty || txtDateOnMarket.touched))">
                <p class="redtext" *ngIf="txtDateOnMarket.errors">
                  Please enter a valid date
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="floatinghead clearfix">
            <label class="bluelabel">Investment Highlights</label>
            <button href="#" tooltip="Add Investment Highlights" (click)="onAddInvestmentHighlight()" placement="left" class="right-btn btn  btn-circle btn-green adduserbtn">
              <i class="icofont icofont-plus icon" aria-hidden="true"></i>
            </button>
          </div>

          <div class="table-responsive">
            <table class="table basictable">
              <thead>
                <tr>
                  <!--<th style="width:50px">#</th>-->
                  <th>Title</th>
                  <th>Description</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let ih of model.InvestmentHighlights; let i = index">
                  <!--<td>{{i + 1}}</td>-->
                  <td>
                    <label class="form-label">&nbsp;</label>
                    <input class="form-control" type="text" [formControlName]="'txtIHTitle' +getIhId(i)" required maxlength="150" [(ngModel)]="ih.Title" />
                    <div *ngIf="(propForm.get('txtIHTitle' +getIhId(i)).invalid && isSubmitted)||(propForm.get('txtIHTitle' +getIhId(i)).invalid && (propForm.get('txtIHTitle' +getIhId(i)).dirty || propForm.get('txtIHTitle' +getIhId(i)).touched))">
                      <p class="redtext" *ngIf="propForm.get('txtIHTitle' +getIhId(i)).errors.required">
                        Title is required
                      </p>
                      <p class="redtext" *ngIf="propForm.get('txtIHTitle' +getIhId(i)).errors.spaceOnly">
                        The value cannot be only white spaces
                      </p>
                    </div>
                  </td>
                  <td>
                    <textarea class="form-control" [formControlName]="'txtIHDesc' + getIhId(i)" maxlength="500" [(ngModel)]="ih.Description"></textarea>
                  </td>
                  <td>
                    <a class="remove" (click)="onRemoveInvestmentHighlight(ih)" href="javascript:void();" placement="top" triggers="mouseenter:mouseleave" tooltip="Remove" ng-reflect-tooltip="Remove"
                       ng-reflect-placement="top">
                      <i aria-hidden="true" class="icofont icofont-close"></i>
                    </a>
                  </td>
                </tr>
                <tr *ngIf="model.InvestmentHighlights.length === 0">
                  <td colspan="4">
                    <div class="nodata">
                      <i class="icofont icofont-warning icon"></i>
                      <p>No Investment Highlights Added</p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="border-div">
      <h2 class="mainhead">
        <span class="text">Documents &amp; Images</span>
      </h2>
      <!--<div class="margin-bottom-20 clearfix">
        <div class="rightcheckbox ">
          <label class="custom-checkbox margin-right-20" for="checkbox13">
            <input formControlName="chkOfferMemoReqApproval" [(ngModel)]="model.OfferMemoReqApproval" id="checkbox13" type="checkbox">Offering Memorandum access requires approval
            <i></i>
          </label>

          <label class="custom-checkbox  margin-right-20" for="checkbox14">
            <input formControlName="chkDueDiligenceReqApproval" [(ngModel)]="model.DueDiligenceReqApproval" id="checkbox14" type="checkbox">Due Diligence access requires approval
            <i></i>
          </label>

          <label class="custom-checkbox " for="checkbox15">
            <input formControlName="chkConfidentialityAgreement" [(ngModel)]="model.ConfidentialityAgreement" id="checkbox15" type="checkbox">Confidentiality Agreement Required
            <i></i>
          </label>
        </div>
      </div>-->
      <div class="om-dd-check-wrapper margin-bottom-20 d-felx">
        <div style="display:inline-block;" class="inline-block">
          <ul class="statuslisting list-filter-02 doc-listing  margin-bottom-0">
            <li class="transition margin-bottom-10">
              <div class="list-filter-div d-flex flex-wrap-wrap">
                <div class="inner-div d-flex flex-wrap-wrap">
                  <label>
                    Offering Memorandum:
                  </label>
                  <label class="custom-checkbox margin-right-20" for="checkbox13">
                    <input formControlName="chkOfferMemoReqApproval" [(ngModel)]="model.OfferMemoReqApproval" id="checkbox13" type="checkbox">Requires Approval
                    <i></i>
                  </label>
                  <label class="custom-checkbox margin-right-20" for="checkbox14">
                    <input formControlName="chkConfidentialityAgreement" [(ngModel)]="model.ConfidentialityAgreement" id="checkbox15" type="checkbox">Requires Confidentiality Agreement
                    <i></i>
                  </label>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div style="display:inline-block;" class="inline-block">
          <ul class="statuslisting list-filter-02 doc-listing  margin-bottom-0">
            <li class="transition">
              <div class="list-filter-div">
                <div class="inner-div d-flex flex-wrap-wrap">
                  <label>
                    Due Diligence:
                  </label>
                  <label class="custom-checkbox margin-right-20" for="checkbox15">
                    <input formControlName="chkDueDiligenceReqApproval" [(ngModel)]="model.DueDiligenceReqApproval" id="checkbox14" type="checkbox">Requires Approval
                    <i></i>
                  </label>
                  <label class="custom-checkbox margin-right-20" for="checkbox14">
                    <input formControlName="chkDDConfidentialityAgreement" [(ngModel)]="model.DDConfidentialityAgreement" id="checkbox15" type="checkbox">Requires Confidentiality Agreement
                    <i></i>
                  </label>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="floatinghead clearfix">
        <h3 class="bluelabel">Documents</h3>

        <div class="uploadfile  btn  btn-circle btn-green " tooltip="Upload Documents" placement="left">
          <input type="file" (change)="onNewFileUpload($event)" multiple #propDoc class="fileupload">
          <span class="icofont icofont-upload-alt icon"></span>
        </div>
        <!--<file-upload (selectedFilesListEmitter)=onNewFileUpload($event) [uploadType]="fileUploadType" [extensionType]="fileExtensionType" [clearFilescounter]="clearFiles"></file-upload>
        <label class="alert-danger">{{errorMessageForLOI}}</label>-->
      </div>
      <div>
        <p class="commonpara">
          <i container="body" class="userpermissiontooltip margin-right-5" aria-hidden="true" placement="right">
            <img src="/assets/img/Frame.svg" class="info-icon-blue-position">
          </i>
          <span>Allowed file types: .PDF</span>
        </p>
      </div>
      <div class="table-responsive margin-bottom-20">
        <table class="table basictable">
          <thead>
            <tr>
              <th style="width:50px">#</th>
              <th>Document Title</th>
              <th>Category</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let doc of propertyDocuments; let i = index;">
              <td>
                <p>{{i + 1}}</p>
              </td>
              <td>
                <p>{{doc.Name}}</p>
              </td>
              <td>
                <label class="select">
                  <select [(ngModel)]="doc.CategoryId" [formControlName]="'cmbDocCat' + getDocId(i)" class="form-control ">
                    <option [ngValue]="null">Select</option>
                    <option *ngFor="let cat of docCategories" [ngValue]="cat.id">{{cat.description}}</option>
                  </select>
                  <i></i>
                </label>
                <div *ngIf="(propForm.get('cmbDocCat' + getDocId(i)).invalid && isSubmitted) || (propForm.get('cmbDocCat' + getDocId(i)).invalid && (propForm.get('cmbDocCat' +getDocId(i)).dirty || propForm.get('cmbDocCat' +getDocId(i)).touched))">
                  <p class="redtext" *ngIf="propForm.get('cmbDocCat' +getDocId(i)).errors.required">
                    Document category is required
                  </p>
                </div>
              </td>
              <td>
                <a class="view" *ngIf="doc.Url != null && doc.Url.length > 0" href={{doc.Url}} download target="_blank" placement="top" triggers="mouseenter:mouseleave" tooltip="Download" ng-reflect-tooltip="Download"
                   ng-reflect-placement="top" triggers="hover">
                  <i aria-hidden="true" class="icofont icofont-download-alt"></i>
                </a>
                <a href="javascript:void(0);" (click)="onRemoveDocument(i)" class="remove" tooltip="Remove" placement="top">
                  <i class="icofont icofont-close" aria-hidden="true"></i>
                </a>
              </td>
            </tr>
            <tr *ngIf="propertyDocuments.length === 0">
              <td colspan="4" style="text-align: center; font-weight: normal; color: gray">

                <div class="nodata">
                  <i class="icofont icofont-warning icon"></i>
                  <p>No Documents Added</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--new upload style-->
      <!--<ul class="imglisting informationupload">
          <li class="addnew">
              <input   type="file" (change)="onNewFileUpload($event)" multiple #propDoc>
              <span class="icofont icofont-upload-alt"></span>
              <p>Click here to Upload Documents</p>
          </li>
      </ul>-->
      <!--new upload style ends-->

      <h3 class="bluelabel margin-bottom-15">Property Images</h3>
      <div class="floatinghead clearfix">
        <p class="commonpara">
          (For connectivity below the Wifi speed(like 4G&3G), upload photos with less than 3-4MB size to reduce the upload
          time duration.)
        </p>
        <div class="uploadfile  btn  btn-circle btn-green " tooltip="Upload Images" placement="left">
          <input #propImage class="fileupload" (change)="onNewImageUpload($event)" multiple type="file">
          <span class="icofont icofont-upload-alt icon"></span>
        </div>
      </div>
      <div class="table-responsive margin-bottom-20">
        <table class="table basictable imglisting">
          <thead>
            <tr>
              <th style="width:50px">#</th>
              <th>&nbsp;</th>
              <th>&nbsp;</th>
              <th>Alt Text</th>
              <th>Caption</th>
              <th>Description</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let file of propertyImages; let i = index;" class="draggable"
                [class.active]="draggedOverIndex == i">
              <td>
                <p>{{i+1}}</p>
              </td>
              <td class="image-div">
                <div class="img-check" [ngClass]="(i == 0 && isContainsIsDefault()) || file.IsDefault? 'active': ''">
                  <label class="custom-checkbox ">
                    <input type="radio" ondragover="return false" name="default" (click)="setAsDefault(file.Id,i)">
                    <i class="helper"></i>
                  </label>
                </div>
                <div class="margin-top-15"><div>Default</div></div>
              </td>
              <td draggable="true"
                  (dragover)="allowDrop($event, i)"
                  (dragstart)="onDragStart(i)"
                  (drop)="onDrop($event,i)" class="img_drag">
                <span>
                  <img [src]="file.Url" style="width:75px;height:53px;" />
                </span>
              </td>
              <td>
                <input class="form-control" ondragover="return false" type="text" maxlength="100" [formControlName]="'txtalText'+getImageId(i)" [(ngModel)]="file.AlText" />
              </td>
              <td>
                <input class="form-control" ondragover="return false" type="text" [formControlName]="'txtCaption'+getImageId(i)" maxlength="100" [(ngModel)]="file.Caption" />
                <input class="form-control" type="hidden" [formControlName]="'txtDisplayOrder'+getImageId(i)" />
              </td>
              <td>
                <textarea class="form-control" ondragover="return false" style="padding:0px 15px !important;" [formControlName]="'txtLongDescription'+getImageId(i)" maxlength="500" [(ngModel)]="file.Description"></textarea>
              </td>
              <td>
                <a href="javascript:void(0);" ondragover="return false" (click)="onRemoveImage(file.Id,i)" class="remove" tooltip="Remove" placement="top">
                  <i class="icofont icofont-close" aria-hidden="true"></i>
                </a>
              </td>
            </tr>
            <tr *ngIf="propertyImages.length === 0">
              <td colspan="7" style="text-align: center; font-weight: normal; color: gray">

                <div class="nodata">
                  <i class="icofont icofont-warning icon"></i>
                  <p>No Image Added</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row" style="margin-bottom:35px !important;">
      </div>
      <!--<h3 class="bluelabel margin-bottom-10">Property Images</h3>
      <p class="commonpara">
        (For connectivity below the Wifi speed(like 4G &3G) , upload photos with less than 3-4mb size to reduce the upload
        time duration.)
      </p>
      <ul class="imglisting">
        <li *ngFor="let file of propertyImages; let i = index">
          <span class="img-download" (click)="getFile(file.Url, file.Name)">
            <img [src]="file.Url" />
            <i class="fa fa-download" aria-hidden="true"></i>
          </span>

          <div class="img-check" [ngClass]="(i == 0 && isContainsIsDefault()) || file.IsDefault? 'active': ''">
          <input type="radio"  name="default" (click)="setAsDefault(file.Id,i)" />
      <i></i>Set as Default
          <label class="custom-checkbox ">
            <input type="radio" name="default" (click)="setAsDefault(file.Id,i)">
            <i class="helper"></i>Default
          </label>
        </div>
        <a href="javascript:void(0);" (click)="onRemoveImage(file.Id,i)" class="remove" triggers="hover" ng-reflect-placement="top" ng-reflect-tooltip="Remove" placement="top" tooltip="Remove">
          <i class="icofont icofont-close" aria-hidden="true"></i>
        </a>
      </li>
      <li class="addnew add-new-img" tooltip="Upload New Image">
        <label>
          <input #propImage (change)="onNewImageUpload($event)" multiple type="file">
          icofont-plus
          <span class="icofont icofont-upload-alt"></span>
            <p>Upload New</p>
          </label>
        </li>
      </ul>-->
      <h3 class="bluelabel margin-bottom-10">Videos</h3>
      <div class="row">
        <div class="col-md-6 col-sm-6 col-xs-12">
          <div class="form-group">
            <label class="form-label">Paste your vimeo video URL here</label>
            <input formControlName="txtVideoUrl" [(ngModel)]="model.VideoUrl" class="form-control " type="text">
            <div *ngIf="(txtVideoUrl.invalid && isSubmitted) || (txtVideoUrl.invalid && (txtVideoUrl.dirty || txtVideoUrl.touched))">
              <p class="redtext" *ngIf="txtVideoUrl.errors.vimeoUrl">
                Invalid Vimeo video url
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="border-div" *ngIf="!authService.DataEntryStaff()">
      <div class="floatinghead floatinghead-xs clearfix">
        <h2 class="mainhead">
          <span class="text">Contact Info/ B+E Broker</span>
        </h2>
        <button href="#" (click)="openModal(template,'panlestyle')" tooltip="Add broker" placement="left" class="right-btn btn  btn-circle btn-green adduserbtn">
          <i class="icofont icofont-plus icon" aria-hidden="true"></i>
        </button>
        <!--<div class="btn-group pull-right" dropdown>
          <button id="quick-save" dropdownToggle type="button" class="right-btn btn  btn-circle btn-green adduserbtn"
                  aria-controls="dropdown-basic">
            <i class="icofont icofont-plus icon" aria-hidden="true"></i>
          </button>
          <ul id="quick-save" *dropdownMenu class="dropdown-menu"
              role="menu" aria-labelledby="button-basic">
            <li role="menuitem"><a class="dropdown-item" (click)="openModalBrokerage(BrokerageBroker,'panlestyle')">Add Existing Broker</a></li>
            <li role="menuitem"><a class="dropdown-item" (click)="openModalBroker(BrokerTemplate,'panlestyle','')">Add New Broker</a></li>
          </ul>



        </div>-->
      </div>
      <div *ngIf="this.model.ContactOrBrokerInfo === null || this.model.ContactOrBrokerInfo.length === 0" class="nodata">
        <i class="icofont icofont-warning icon"></i>
        <p>No Brokers Added </p>
      </div>
      <div *ngIf="this.model.ContactOrBrokerInfo !== null && this.model.ContactOrBrokerInfo.length > 0" class="table-responsive">
        <table class="table basictable">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Licence</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Contact</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let licence of model.ContactOrBrokerInfo; let i = index">
              <td>
                <p>{{i + 1}}</p>
              </td>
              <td>
                <p>{{licence.Name}}</p>
              </td>
              <td>
                <p>{{licence.License}}</p>
              </td>
              <td>
                <p>{{licence.PhoneNumber ? (licence.PhoneNumber | phone) : '-'}}</p>
              </td>
              <td>
                <p>
                  <a href="javascript:void(0)">{{licence.Email ? licence.Email : '-' }}</a>
                </p>
              </td>
              <td>
                <p> {{ getContactTypeDisplayName(licence.ContactTypeId) }} </p>
              </td>
              <td>
                <a href="javascript:void(0);" (click)="openModalForEdit(template,'panlestyle', i)" class="blueone" tooltip="Edit" placement="top">
                  <i class="icofont icofont-ui-edit" aria-hidden="true"></i>
                </a>
                <a href="javascript:void(0);" (click)="onRemoveLicence(i)" class="remove" tooltip="Remove" placement="top">
                  <i class="icofont icofont-close" aria-hidden="true"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="border-div" *ngIf="!isPortfolio || (isPortfolio && !authService.DataEntryStaff())">
      <div class="floatinghead floatinghead-xs clearfix">
        <h2 class="mainhead">
          <span class="text">Seller Info</span>
        </h2>
        <button href="#" (click)="openModalForSeller(PropertySellerAdd,'panlestyle')" tooltip="Add Seller" placement="left" class="right-btn btn  btn-circle btn-green adduserbtn">
          <i class="icofont icofont-plus icon" aria-hidden="true"></i>
        </button>
      </div>
      <div *ngIf="model.PropertySellers.length === 0" class="nodata">
        <i class="icofont icofont-warning icon"></i>
        <p>No Sellers Added</p>
      </div>
      <div *ngIf="model.PropertySellers.length > 0" class="table-responsive">
        <table class="table basictable">
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Remove</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let seller of model.PropertySellers; let i = index">
              <td>
                <p>{{i + 1}}</p>
              </td>
              <td>
                <p>{{seller.Name}}</p>
              </td>
              <td>
                <p>{{seller.Phone ? (seller.Phone | phone) : '-'}}</p>
              </td>
              <td>
                <p>
                  <a href="javascript:void(0)">{{seller.Email ? seller.Email : '-' }}</a>
                </p>
              </td>
              <td>
                <a href="javascript:void(0);" (click)="onRemoveSeller(i)" class="remove" tooltip="Remove" placement="top">
                  <i class="icofont icofont-close" aria-hidden="true"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="border-div" *ngIf="authService.Admin()||authService.SuperAdmin()">
      <div class="floatinghead floatinghead-xs clearfix">
        <h2 class="mainhead">
          <span class="text">Notes</span>
        </h2>
        <textarea [(ngModel)]="model.Notes" formControlName="txtNotes"
                  class="form-control property-description" maxlength="200"
                  rows="3"></textarea>
      </div>
    </div>


    <div class="text-right margin-bottom-30" *ngIf="!isPortfolio">
      <button (click)="cancelSave()" class="btn btn-default btn-lg margin-bottom-10">Cancel</button>
      <button (click)="saveChanges(null,1)" *ngIf="!model.LiveListingId && (!this.isInEditMode ||  dataEntryPropertyStatusId == propertyStatus.Draft) &&  authService.DataEntryStaff()" class="btn btn-border btn-lg margin-bottom-10">Save As Draft</button>
      <!--<button (click)="approveTenantGuarantor()" *ngIf="(model.TenantNameText || model.GuarantorName) && !authService.DataEntryStaff()" class="btn btn-success btn-lg margin-bottom-10">Approve</button>-->
      <button (click)="saveChanges(null,2)" *ngIf="!model.LiveListingId && !authService.DataEntryStaff()" class="btn btn-success btn-lg margin-bottom-10">Save</button>
      <button (click)="saveChanges(ChangeUpdate,3)" class="btn btn-success btn-lg margin-bottom-10">{{(!authService.DataEntryStaff()) ? 'Approve & List': ('Save to 1031 Listing')}}</button>
    </div>
    <div class="text-right margin-bottom-30" *ngIf="isPortfolio">
      <button (click)="cancelSave()" class="btn btn-default btn-lg margin-bottom-10">Cancel</button>
      <button (click)="saveChanges(null,1)" *ngIf="!model.LiveListingId && (!this.isInEditMode ||  dataEntryPropertyStatusId == propertyStatus.Draft) &&  authService.DataEntryStaff()" class="btn btn-border btn-lg margin-bottom-10">Save Portfolio As Draft</button>
      <button (click)="saveChanges(null,2)" *ngIf="!model.LiveListingId && !authService.DataEntryStaff()" class="btn btn-success btn-lg margin-bottom-10">Save Portfolio</button>
      <button (click)="saveChanges(ChangeUpdate,3)" class="btn btn-success btn-lg margin-bottom-10">{{(!authService.DataEntryStaff()) ? 'Approve & List Portfolio': ('Save Portfolio to 1031 Listing')}}</button>
    </div>
  </div>   <!--</div>-->

</form>
<!-- <script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyCkUOdZ5y7hMm0yrcCQoCvLwzdM6M8s5qk&libraries=places&callback=initAutocomplete"
    async defer></script> -->
<ng-template #template>
  <app-broker-details (save)="onAddBrokerLicence($event)" (close)="closeModal($event)" [modalRef]="modalRef" [stateId]="model.StateId"
                      [isEdit]="isBrokerFormEditMode" [stateName]="stateName" [currentBrokerLicense]="currentBrokerLicense"></app-broker-details>
</ng-template>
<ng-template #templateSolidDetails>
  <app-sold-details (save)="addSalesDetails($event)" [property]="model" [currentSalesDetails]="currentSalesDetails" (close)="closeModal($event)"></app-sold-details>
</ng-template>

<ng-template #ChangeUpdate>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">There were some updates on the property source site. Did we capture those in B+E?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-lg btn-success" (click)="callSaveApiMethod(false)">NO</button>
      <button class="btn btn-lg btn-success" (click)="callSaveApiMethod(true)">YES</button>
    </div>
  </div>
</ng-template>

<ng-template #PropertyForSelection>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">This property will be listed for {{propertyFor}}</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-success" (click)="modalRefPropertyForSelection.hide()">OK</button>
    </div>
  </div>
</ng-template>

<ng-template #PropertyForConfirmation>
  <div class="modal-body padding30">
    <div class="form-group" *ngIf="(!authService.DataEntryStaff()||(authService.DataEntryStaff&&(!model.TenantNameText && !model.GuarantorName)))">
      <h6 class="displayvalue">Are you sure you want to list {{ model.TenantName !=null?model.TenantName:model.DisplayName }} for {{propertyFor}} ? </h6>
    </div>
    <div class="form-group" *ngIf="(authService.DataEntryStaff()&&(model.TenantNameText ||model.GuarantorName))">
      <h6 class="displayvalue">Are you sure you want to submit this {{isPortfolio ? 'portfolio' : 'property'}} for approval? </h6>
    </div>

    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefPropertyForConfirmation.hide()">NO</button>
      <button class="btn btn-lg btn-success" *ngIf="!authService.DataEntryStaff()" (click)="saveMethod(ChangeUpdate)">YES</button>
      <button *ngIf="authService.DataEntryStaff()" class="btn btn-lg btn-success" (click)="saveMethod(ChangeUpdate)">Proceed</button>
    </div>
  </div>
</ng-template>



<ng-template #BrokerageBroker>
  <app-brokerage-broker-add [modalRef]="modalRef" [selectedBrokers]="selectedBrokers" [selectedBrokerage]="brokerageName" (addBroker)="addBroker($event);" (closeModal)="closeModalDataEntry($event)" [selectedBrokerageId]="brokerageId"></app-brokerage-broker-add>
</ng-template>

<ng-template #templateAutoCalcRentTerm>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Auto Calculate Rent Term?</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide();setAutoCalcRentTermPreviousValue();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Entries will be lost when you check this option. Are you sure you want to proceed?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide();setAutoCalcRentTermPreviousValue();">No</button>
      <button class="btn btn-lg btn-primary" (click)="setAutoCalcRentTerm();modalRef.hide();">Yes</button>
    </div>
  </div>
</ng-template>

<ng-template #templateBrockerDelete>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Broker</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRemoveBrockerRef.hide();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Are you sure to delete broker?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRemoveBrockerRef.hide();">No</button>
      <button class="btn btn-lg btn-primary" (click)="onRemoveBrokers(this.brockerIndex);modalRemoveBrockerRef.hide();">Yes</button>
    </div>
  </div>
</ng-template>

<ng-template #Duplicate>
  <div class="modal-body padding30">
    <div class="form-group">
      <h6 class="displayvalue">A property with the same tenant name and address exists in the application. Would you like to continue ?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRefDuplicates.hide();">NO</button>
      <button class="btn btn-lg btn-success" (click)="saveMethodAfterDuplicateCheck(ChangeUpdate)">YES</button>
    </div>
  </div>
</ng-template>

<ng-template #PropertySellerAdd>
  <app-shared-user-list [modalRef]="modalRefSeller" [userRoles]="'seller'" (selectedUserEvent)="addSeller($event);" [selectedUserId]="selectedUserId"></app-shared-user-list>
</ng-template>

<ng-template #PropertySuggest>
  <app-portfolio-property-suggest [suggested]="suggested" (close)="onClose($event)" [showOnlyZCF]="model.OnlyZCF" (selectedProperties)="selectedProperties($event)" [propertyId]="this.model.Id" [statusId]="this.model.PropertyForId" [isDataEntryProperty]="true"></app-portfolio-property-suggest>
</ng-template>

<ng-template #DuplicateProperties>
  <app-duplicate-properties [duplicatePropertyList]="duplicatePropertyList" [modalRef]="modalRefPrDuplicate"></app-duplicate-properties>
</ng-template>

<ng-template #BrokerTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{labelForAddOrEdit}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <label class="form-label">
        Brokerage
        <span class="star">*</span>
      </label>
      <label class="select">
        <select class="form-control" #brokerageFromInput="ngModel" [disabled]="FromBrokerageMaster" [(ngModel)]="brokerageBrokerInputModel.BrokerageId" (change)="onBrokerageChange();">
          <option value="0">--Select--</option>
          <option *ngFor="let itemFrom of brokerageList" [(ngValue)]="itemFrom.Id">{{itemFrom.BrokerageName}}</option>
        </select>
        <i></i>
      </label>
      <p class="redtext" *ngIf="(brokerageValid) || (brokerageBrokerInputModel.BrokerageId == 0 && brokerageFromInput.touched)">Brokerage is required</p>
    </div>
    <div class="form-group">
      <label class="form-label">First Name<span class="red">*</span></label>
      <input class="form-control" (keyup)="onBrokerInfoKeydown()" #brokerNameinput="ngModel" [(ngModel)]="brokerageBrokerInputModel.BrokerName" required type="text" maxlength="100">
      <p class="redtext" *ngIf="(brokerNameValid || (brokerNameinput.invalid && brokerNameinput.touched))">First name is required </p>
    </div>
    <div class="form-group">
      <label class="form-label">Last Name<span class="red">*</span></label>
      <input class="form-control" (keyup)="onBrokerInfoKeydown()" #brokerLastNameinput="ngModel" [(ngModel)]="brokerageBrokerInputModel.LastName" required type="text" maxlength="100">
      <p class="redtext" *ngIf="(lastNameValid || (brokerLastNameinput.invalid && brokerLastNameinput.touched))">Last name is required </p>
    </div>
    <div class="form-group">
      <label class="form-label">Email<span class="red">*</span></label>
      <input class="form-control" (keyup)="onBrokerInfoKeydown()" #emailinput="ngModel" autocomplete="off" maxlength="100" required [(ngModel)]="brokerageBrokerInputModel.Email">
      <p class="redtext" *ngIf="((emailValid) || emailinput.invalid && emailinput.touched) && emailvalidation=='' ">Email is required</p>
      <p class="redtext" *ngIf="(emailvalidation!='' && brokerageBrokerInputModel.Email!='' )">{{emailvalidation}}</p>
    </div>


    <div class="form-group">
      <label class="form-label">Phone<span class="red">*</span></label>
      <input class="form-control" (keyup)="onBrokerInfoKeydown()" #phoneNumberinput="ngModel" required [(ngModel)]="brokerageBrokerInputModel.Phone" mask='(000) 000-0000' maxlength="20" id="txtPhone">
      <p class="redtext" *ngIf="((phoneValid) || (phoneNumberinput.invalid && phoneNumberinput.touched) )&& phoneValidation =='' ">Phone number is required</p>
      <p class="redtext" *ngIf="(phoneValidation!='' && brokerageBrokerInputModel.Phone !='')">{{phoneValidation}}</p>
    </div>

    <div class="form-group">
      <label class="form-label">Title<span class="red">*</span></label>
      <input class="form-control" (keyup)="onBrokerInfoKeydown()" #titleinput="ngModel" required [(ngModel)]="brokerageBrokerInputModel.Title" maxlength="100" id="txtTitle">
      <p class="redtext" *ngIf="(brokerTitleValid || (titleinput.invalid && titleinput.touched) )">Title is required</p>
    </div>


    <div class="text-right">
      <button class="btn btn-lg btn-default" id="closeModal" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-lg btn-success" [disabled]="disabledAddOrEditBtn" (click)="addOrEditBroker();">Save</button>
    </div>
  </div>
</ng-template>
